/* eslint-disable array-callback-return */
/* eslint-disable no-redeclare */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import Select from 'react-select';
// import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
// import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
// import 'ag-grid-community/styles/ag-theme-balham.css'; // Optional theme CSS
// import 'ag-grid-enterprise';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import redirectURL from '../redirectURL';
import { getDeptCode, withDeptCode } from '../common/deptCode'; // page's ?dept_code (none = SPD): SLA hints + dept-filtered list
import Constants from "../constants";
import { getHyphenDDMMMYYYYHHMM, getHyphenDDMMYYYY, getHyphenYYYYMMDD, getHyphenDDMMMYYYY } from "../common/utils";
// import { createStaticHandler } from '@remix-run/router';
// import BillingTripsData from "./BillingTripsDataGrid";
import CSVFileValidator from 'csv-file-validator';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import ViewPOD from "./viewpodbutton";
import UploadPOD from "./uploadpodbutton";
import RevertPOD from "./revertpodbutton";
import CofUpload from "./cofUploadButton";
import EpodGateActions from "./epodgateactions";
import DealerConditionActions from "./dealerConditionActions";
import ReviewPodSlider from "./reviewPodSlider";
import DamageFilesAction from "./damageFilesAction";
import AlReviewCellAction from "./alReviewCellAction";
import AlUnifiedActions from "./alUnifiedActions";
import { getAlActions } from "./alActions";
import AlReviewActionModal from "./alReviewActionModal";
import ViewLogsButton from "./viewLogsButton";
import ViewLogsSlider from "./viewLogsSlider";
import { getWorkflowDisplayStatus, STATUS_BADGE_CLASS, STATUS_LABELS, getWorkflowStatusTooltip, getPodVerificationStatus, getOcrReviewState } from "./workflowStatus";
import { isIndependentRow, isAwaitingDealer } from "./epodDealerFlow";
import Datetime from 'react-datetime';
// import ViewBatchItems from "./viewbatchitems";
import "react-datetime/css/react-datetime.css";
import download from 'js-file-download';
import $ from 'jquery';
//import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
import CourierActions from '../courier/courierActions';
import { times } from 'lodash';
var moment = require('moment');
var getDisplayLabel = require('./epodLabels').getDisplayLabel;
var resolvePodTabsConfig = require('./epodPodTabsConfig').resolvePodTabsConfig;
var googleAnalytics = require("../common/googleanalytics");

// One "AL Action" column carrying every approval the AL team owes on a row (held e-POD upload,
// dealer NDV review, and any future step - see alActions.js). Set to false to bring back the two
// original columns ("AL Action" and "AL Review Action") exactly as they were.
const UNIFIED_AL_ACTIONS = true;

export default class EpodScreen extends Component {

    state = {
        loadshow: 'show-n',
        overly: 'show-n',
        // Config-driven POD tab visibility/default view - DB-backed (app_configurations,
        // service_name: epod_pod_tabs), fetched in componentDidMount via loadPodTabsConfig(). This
        // resolved value (never the raw fetch response) is what the tab buttons, the Total tile,
        // and loadTrips' initial-view logic all read - one source of truth, per that task's own
        // explicit instruction not to scatter configuration checks around the component. Starts at
        // the resolver's own generic, non-business-specific safe fallback (== today's original
        // behavior for every user_type) so the screen never blocks on the config fetch and never
        // needs a loading state of its own for this - it just re-renders once the real DB config
        // arrives, same pattern already used for dealerConditionOptions below.
        podTabsConfig: resolvePodTabsConfig(localStorage.getItem('user_type'), null),
        oRowData: [],
        totalrecords: [],
        pending: [],
        liabilityCnt: [],
        modules: AllModules,
        alert: null,
        show: false,
        basicTitle: '',
        basicType: "default",
        isuploadcsv: 0,
        // e-POD late-upload gate (epod_late_upload config). Defaults are "feature off / no
        // actions", so nothing new renders until the backend says otherwise.
        epodGateEnabled: false,
        epodGateActions: {},
        // Whether THIS login may approve/reject a held upload (backend-decided, from
        // epodLateUploadOptions.can_review): false for the LSP and the dealer. Fails closed.
        epodGateCanReview: false,
        epodGateAllowedDays: null,
        epodGateMaxRemarksLength: 500,
        // Per-row busy guard for the single-click Approve action (Reject already has its own
        // mandatory-remarks modal + epodRejectSubmitting) - same docBusyRowId pattern
        // alReviewScreen.js already uses for its own per-row document actions, prevents a rapid
        // double-click from firing two API calls for the same row.
        epodGateActionBusyRowId: null,
        // Which epod_gate_status values mean "this upload is actually queued for OCR" - sourced
        // from the backend (epodLateUploadService.OCR_ELIGIBLE_STATES via /epodLateUploadOptions),
        // never hardcoded here. Used only to derive a display-only "In Progress" OCR Status for a
        // row that's been uploaded but has no OCR result yet - no field is ever written for this.
        epodOcrEligibleStates: [],
        // AL decision on an e-POD that failed OCR on its last allowed upload
        // (epod_late_upload.ocr_manual_review via /epodLateUploadOptions). {} = feature off.
        epodOcrReviewOptions: {},
        // Approve / Reject (with remarks) modal for that decision: { row, action, remarks, error, submitting }.
        epodOcrReview: null,
        // e-POD Revert POD lock (epod_revert_lock config) - hides "Revert POD" once a row has
        // reached a terminal state (Dealer Condition Clean / AL Review signed document). Defaults
        // to "feature off" until the backend confirms otherwise, so Revert POD looks exactly as it
        // does today until this loads - same fail-closed pattern as epodGateEnabled above.
        epodRevertLockEnabled: false,
        epodRevertLockOnDealerClean: true,
        epodRevertLockOnDealerDamage: true,
        epodRevertLockOnSignedDocument: true,
        epodRevertLockAppliesTo: 'all',
        // Whether the "Closed" tab additionally requires the dealer/AL-review workflow to have
        // actually reached a terminal outcome, not just "a POD file exists" (epod_revert_lock
        // config's close_up_requires_workflow_complete). Defaults to false - today's exact
        // upload-only Closed-tab behavior - until the backend confirms otherwise.
        epodCloseUpRequiresWorkflowComplete: false,
        // Mandatory-remarks reject modal state. Cancel/close always resets this back to these
        // defaults WITHOUT calling the backend - the E-POD is left completely unchanged.
        epodRejectModalShow: false,
        epodRejectRow: null,
        epodRejectRemarks: '',
        epodRejectSubmitting: false,
        epodRejectError: '',
        // POD Revert (epod_pod_revert config) - feature flag for the "Reverted By/At/Reason"
        // columns, plus the mandatory-reason confirmation modal state. Cancel/close always resets
        // this back to these defaults WITHOUT calling the backend, same as the Reject modal above.
        epodPodRevertEnabled: false,
        epodPodRevertRequireReason: true,
        epodPodRevertMaxRemarksLength: 500,
        epodPodRevertModalShow: false,
        epodPodRevertRow: null,
        epodPodRevertReason: '',
        epodPodRevertSubmitting: false,
        epodPodRevertError: '',
        // COF Note upload (TRANSPORTER only) - reuses Action 19's EXISTING
        // /billing/alReviewDocumentSignedUpload / alReviewDocumentSignedDownload endpoints (the
        // same ones alReviewScreen.js's "Upload Signed Doc"/"View Signed Doc" already call). Column
        // only ever renders once epod_document_type is 'cof' (set by generateDocument's COF branch
        // after the required AL/Admin approval) - see the "COF Note" column def below. Cancel/close
        // always resets this back to these defaults WITHOUT calling the backend, same pattern as
        // the Reject/Revert modals above.
        cofUploadModalShow: false,
        cofUploadRow: null,
        cofUploadFile: null,
        cofUploadSubmitting: false,
        cofUploadError: '',
        rowData: [],
        // EPOD Phase 3 - Dealer Condition (Clean/Shortage/Damage/Reopen) brought into this screen
        // for CUSTOMER logins only. options/queueMap come 1:1 from the existing
        // /billing/dealerConfirmationOptions and /billing/dealerConfirmationQueue responses - the
        // backend remains the sole source of truth for eligibility, never recomputed here. Only
        // ever populated when user_type === "CUSTOMER" (see componentDidMount); every field below
        // is namespaced (dealerCondition*/dc*) so it can never collide with this screen's existing
        // state.
        dealerConditionOptions: {
            enabled: false, shortage_sla_hours: 48, max_remarks_length: 500, damage_images: { min_count: 1, max_count: 6 },
            condition_change: { dealer_reopen_enabled: false, require_reopen_remarks: true, max_reopen_count: 1 },
        },
        dealerConditionQueueMap: {},
        // "Review POD" slider (replaces the old separate Clean/Shortage/Damage grid buttons/modals
        // for CUSTOMER users) - a single entry point that opens ReviewPodSlider for the clicked row.
        // All Clean/Shortage/Damage form state now lives inside that component itself; this screen
        // only needs to know WHICH row is currently open.
        reviewPodRow: null,
        // ePOD Activity Log ("View Logs") - read-only slider. Same "only track which row is open"
        // pattern as reviewPodRow above; all fetching lives inside ViewLogsSlider itself.
        viewLogsRow: null,
        // WEB-025 Reopen modal
        dcReopenModalShow: false, dcReopenRow: null, dcReopenRemarks: '', dcReopenSubmitting: false, dcReopenError: '',
        // Damage Files - grid column (ALL user types) + file-list modal. Supersedes the old
        // per-row "View Damage Images" button, which called the unauthenticated
        // /downloadPodDocument endpoint directly from the client with a caller-chosen key. Files
        // are resolved through the new backend-authoritative /billing/dealerDamageFiles endpoint
        // instead and held ONLY in this in-memory state; never persisted anywhere.
        damageFilesCountMap: {},
        damageFilesModalShow: false, damageFilesRow: null, damageFilesItems: [], damageFilesLoading: false, damageFilesError: '',
        // EPOD Phase 4 - AL Review (Action 16) brought inline into this screen for Enmovil/AL admin
        // logins, so approving/rejecting a dealer's NDV doesn't require navigating to the separate
        // /alReview screen. options/queueMap come 1:1 from the existing /billing/alReviewOptions
        // and /billing/alReviewQueue responses (the SAME endpoints alReviewScreen.js already uses,
        // unscoped - AL reviews across all dealers) - the backend remains the sole source of truth
        // for eligibility, never recomputed here. Only ever populated for isAlReviewVisible() (see
        // componentDidMount/loadAlReviewOptions); every field below is namespaced (alReview*) so it
        // can never collide with this screen's existing state.
        alReviewOptions: {
            enabled: false, approval_actions: { approve: false, reject: false },
            // Fails closed (empty) until the backend confirms otherwise - isAlReviewVisible() ORs
            // this against the existing Enmovil-email check, so a real AL_ADMIN/SITE_ADMIN login
            // never sees this column before its own config value has actually loaded.
            visible_user_role_combinations: [],
            require_reject_remarks: true, require_ndv_amount_on_approve: true,
            max_remarks_length: 500, ndv_credit_note_max: 3500,
            // COF View permission (al_review config's own cof_view block) - who sees "View COF
            // Note" once uploaded. Default matches today's production behavior exactly (Admin/
            // Transporter yes, Dealer no) so the COF Note column looks correct even before
            // loadAlReviewOptions' fetch resolves. Display-only - isDocumentAccessAllowed() on the
            // backend is the actual authorization boundary and is never bypassed by this.
            cof_view: { enabled: true, allow_admin: true, allow_transporter: true, allow_dealer: false },
        },
        alReviewQueueMap: {},
        // Detail + Approve/Reject modal (alReviewActionModal.js) - this screen only tracks WHICH
        // row is open; all detail-loading/validation/submit logic lives inside that component.
        alReviewModalRow: null,
        frameworkComponents: {
            courierActions: CourierActions,
            UploadPOD: UploadPOD,
            ViewPOD: ViewPOD,
            RevertPOD: RevertPOD,
            EpodGateActions: EpodGateActions,
            DealerConditionActions: DealerConditionActions,
            DamageFilesAction: DamageFilesAction,
            AlReviewCellAction: AlReviewCellAction,
            AlUnifiedActions: AlUnifiedActions,
            CofUpload: CofUpload,
            ViewLogsButton: ViewLogsButton
        },
        defaultColDef: {
            // flex: 1,
            minWidth: 100,
            filter: true,
            resizable: true,
            initialWidth: 200,
            wrapHeaderText: true,
            autoHeaderHeight: true,
            sortable: true
        },
        detailCellRendererParams: {
            detailGridOptions: {
                columnDefs: [
                    { field: 'callId' },
                    { field: 'direction' },
                    { field: 'number', minWidth: 150 },
                    { field: 'duration', valueFormatter: "x.toLocaleString() + 's'" },
                    { field: 'switchCode', minWidth: 150 },
                ],
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                params.successCallback(params.data.callRecords);
            },
        },
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel"
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }
            ]
        },
        supportField: '',
        flTransporter: {
            label: "All",
            value: ""
        },
        filterTransporters: [{
            label: "All",
            value: ""
        }],
        rowSelection: "multiple",
        startDate: moment.parseZone().format('YYYY-MM'),
        delivered_date: '',
        gc_date: '',
        shipment_completion_date: '',
        manual_csvcontent: [],
        manual_file: '',
        gcWayBillList: [],
        shipType: { label: "All", value: "all" },
        multiplePodDocs: [],
        tabOne: "btn-current",
        tabTow: "btn-defaultc",
        tabThree: "btn-defaultc",
        uFile: "",
        dataType: "pending",
        transit_data_for_update: "",
        show_delivered_date: false,
        delivered_date_for_update: '',
        epodDocforupdate: '',
        errMsg: 'd-none',
        totalclosedpods: [],
        invalidDocketRecords: [],
        ocrVerifiedCount: 0,
        from_date: moment.parseZone(new Date()).subtract(4, "months").format("YYYY-MM-DD"),
        to_date: moment.parseZone(new Date()).format("YYYY-MM-DD"),
        // Single-row Upload POD slider (formPOD/slidershow) - inline failure message shown INSIDE
        // the slider itself, never the global SweetAlert, so a rejected upload doesn't look like it
        // silently vanished. Cleared whenever the slider is (re)opened or closed.
        uploadPodError: '',
        // Double-submit guard for uploadDocument() (both the single-row formPOD and bulk
        // formBulkPOD forms share this one handler) - same purpose/shape as
        // dcReopenSubmitting/epodRejectSubmitting/epodPodRevertSubmitting elsewhere in this file.
        uploadPodSubmitting: false,

    }

    componentDidMount() {
        // let startDate = moment.parseZone().format('YYYY-MM');
        // this.getLiabilityData(startDate)
        this.loadPodTabsConfig()
        this.loadTrips()
        this.loadEpodLateUploadOptions()
        this.loadEpodRevertLockOptions()
        this.loadEpodPodRevertOptions()
        // EPOD Phase 3 - only CUSTOMER (dealer) logins ever need the condition queue/options; no
        // extra network calls for AL/Admin/Transporter/LSP logins, and the new grid column stays
        // hidden for them regardless.
        if (localStorage.getItem("user_type") === "CUSTOMER") {
            this.loadDealerConditionOptions()
            this.loadDealerConditionQueue()
        }
        // EPOD Phase 4 - AL Review inline column. Options are cheap/non-sensitive and always
        // fetched; the queue (real dealer NDV data, unscoped across all dealers) is only fetched
        // once isAlReviewVisible() actually resolves true - decided inside loadAlReviewOptions's
        // own success handler so it always uses the freshest config
        // (al_review.visible_user_role_combinations), never a role list hardcoded here.
        this.loadAlReviewOptions()
    }
    // Enmovil-email login (existing convention, same check used for the OCR diagnostic columns) OR
    // a real AL/site admin (user_type, roles) combination from the config-driven
    // al_review.visible_user_role_combinations list - see alReviewConfig.js's own header comment
    // for why this checks BOTH together rather than role alone (the same role string can exist
    // under a different user_type population with different intended access) or email-domain
    // alone (real AL_ADMIN/SITE_ADMIN accounts have no Enmovil email at all). OR'd against the
    // email check, never a narrowing of who could already see this.
    isAlReviewVisible = (combosOverride) => {
        var email = (localStorage.getItem("email") || "").toLowerCase();
        var isAdminLoginList = ["gowsigan@ashokleyland.com"];
        if (/enmovil\.(in|ai)$/.test(email) || isAdminLoginList.includes(email)) return true;
        var combos = combosOverride || (this.state.alReviewOptions && this.state.alReviewOptions.visible_user_role_combinations) || [];
        var userType = localStorage.getItem('user_type') || '';
        var storedRoles = (localStorage.getItem('roles') || '').split(',').map(function (r) { return r.trim(); }).filter(Boolean);
        return combos.some(function (combo) {
            if (combo.user_type && combo.user_type !== userType) return false;
            var comboRoles = combo.roles || [];
            if (comboRoles.length === 0) return true; // user_type-only combo - no further role restriction
            return comboRoles.some(function (r) { return storedRoles.indexOf(r) !== -1; });
        });
    }

    // ---------------------------------------------------------------------------------------------
    // EPOD Phase 3 - Dealer Condition on epodScreen.js (CUSTOMER only). Reuses the existing
    // /billing/dealerConfirmation* APIs exactly as dealerConfirmationScreen.js does - no new
    // backend endpoint, no client-side eligibility logic. The queue is fetched ONCE (not per row)
    // and looked up by _id from the grid's cellRendererSelector (dealerConditionActions.js).
    // ---------------------------------------------------------------------------------------------
    // DB-backed POD tab visibility/default view (app_configurations, service_name:epod_pod_tabs).
    // Called for every user_type (not gated like the CUSTOMER-only calls below) since TRANSPORTER
    // also needs its own override resolved. On failure, this.state.podTabsConfig simply stays at
    // its safe-fallback initial value (today's original all-tabs-visible/default-to-pending
    // behavior) - fail closed to the pre-existing behavior, never a crash.
    loadPodTabsConfig = () => {
        redirectURL.post("/billing/epodPodTabsOptions", {}, { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    this.setState({ podTabsConfig: resolvePodTabsConfig(localStorage.getItem('user_type'), resp.data.config) });
                }
            })
            .catch(() => { /* keep the safe-fallback value already in state */ });
    }

    loadDealerConditionOptions = () => {
        redirectURL.post("/billing/dealerConfirmationOptions", withDeptCode({}), { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") this.setState({ dealerConditionOptions: resp.data });
            })
            .catch(() => { /* fail closed - options stay at the disabled default */ });
    }

    loadDealerConditionQueue = () => {
        redirectURL.post("/billing/dealerConfirmationQueue", withDeptCode({}), { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    var map = {};
                    (resp.data.rows || []).forEach((r) => { map[String(r._id)] = r; });
                    this.setState({ dealerConditionQueueMap: map });
                    // Force the grid to re-evaluate cellRendererSelector for every row now that
                    // the map changed - AgGrid does not do this automatically on a state change
                    // that isn't rowData itself.
                    if (this.gridApi) this.gridApi.redrawRows();
                }
            })
            .catch(() => { /* leave the previous map in place - fail closed, not fail-blank */ });
    }

    // ---- Review POD (replaces the old separate Clean/Shortage/Damage buttons/modals) -----------
    // Opens ReviewPodSlider for the clicked row. All Clean/Shortage/Damage form state and the
    // actual dealerConfirmClean/Shortage/Damage API calls live inside that component; this screen
    // only tracks which row is open and reacts once a submit attempt (success or failure) is done,
    // exactly mirroring how the old modals used to report back (same toast state, same queue reload).
    onClickReviewPod = (qrow) => {
        this.setState({ reviewPodRow: qrow });
    }
    onCloseReviewPod = () => {
        this.setState({ reviewPodRow: null });
    }

    // ---- View Logs (read-only activity log, available to every user_type on every row) ---------
    onClickViewLogs = (row) => {
        this.setState({ viewLogsRow: row });
    }
    onCloseViewLogs = () => {
        this.setState({ viewLogsRow: null });
    }
    onReviewPodSubmitted = (result) => {
        this.setState({
            reviewPodRow: null,
            show: true, basicType: result.success ? "success" : "danger", basicTitle: result.message,
        });
        // Same reasoning as onAlReviewSubmitted - loadDealerConditionQueue() only refreshes
        // dealerConditionQueueMap (the "Dealer Condition" column's own data source); it never
        // touches this.state.rowData, so "Workflow Status" (reads dealer_confirmation_status/
        // dealer_confirmation_condition straight off the row) stayed stale after Clean/Shortage/
        // Damage until an unrelated later reload. loadTrips() is the same existing mechanism used
        // after every other state-changing action in this screen.
        this.loadDealerConditionQueue();
        this.loadTrips();
    }

    // ---------------------------------------------------------------------------------------------
    // EPOD Phase 4 - AL Review (Action 16) on epodScreen.js (Enmovil/AL admin logins only). Reuses
    // the existing /billing/alReview* APIs exactly as alReviewScreen.js does - no new backend
    // endpoint, no client-side eligibility logic. The queue is fetched ONCE (not per row) and
    // looked up by _id from the grid's cellRendererSelector (alReviewCellAction.js).
    // ---------------------------------------------------------------------------------------------
    loadAlReviewOptions = () => {
        redirectURL.post("/billing/alReviewOptions", withDeptCode({}), { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    this.setState({ alReviewOptions: resp.data });
                    // Only fetch the queue (real dealer NDV data, unscoped across all dealers) once
                    // this login is actually allowed to see it - checked against the FRESH
                    // visible_user_role_combinations just received, not a stale/hardcoded list.
                    if (this.isAlReviewVisible(resp.data.visible_user_role_combinations)) {
                        this.loadAlReviewQueue();
                    }
                }
            })
            .catch(() => { /* fail closed - options stay at the disabled default */ });
    }

    loadAlReviewQueue = () => {
        redirectURL.post("/billing/alReviewQueue", {}, { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    var map = {};
                    (resp.data.rows || []).forEach((r) => { map[String(r._id)] = r; });
                    this.setState({ alReviewQueueMap: map });
                    // Force the grid to re-evaluate cellRendererSelector for every row now that
                    // the map changed - AgGrid does not do this automatically on a state change
                    // that isn't rowData itself.
                    if (this.gridApi) this.gridApi.redrawRows();
                }
            })
            .catch(() => { /* leave the previous map in place - fail closed, not fail-blank */ });
    }

    // ---- AL Review detail + Approve/Reject modal (alReviewActionModal.js) -----------------------
    // This screen only tracks which row is open and reacts once a submit attempt (success or
    // failure) is done - all detail-loading/validation/submit logic lives inside that component,
    // exactly mirroring onClickReviewPod/onReviewPodSubmitted above.
    onClickAlReview = (qrow) => {
        this.setState({ alReviewModalRow: qrow });
    }
    onCloseAlReview = () => {
        this.setState({ alReviewModalRow: null });
        // Cancel / X / backdrop click: reload the grid too, same as after a submit.
        this.loadAlReviewQueue();
        this.loadTrips();
    }
    onAlReviewSubmitted = (result) => {
        // A successful Reject is still a SUCCESSFUL API call - it must not be shown as a failure -
        // but it should render as the existing red/danger alert style (not green) since the
        // business RESULT is a rejection. A successful Approve stays green. A genuine failure
        // (result.success === false) is always red, regardless of which action was attempted.
        this.setState({
            alReviewModalRow: null,
            show: true, basicType: (result.success && result.action !== 'reject') ? "success" : "danger", basicTitle: result.message,
        });
        // loadAlReviewQueue() alone only refreshes alReviewQueueMap (what the "AL Review"/"AL
        // Review Action" columns read) - it never touches this.state.rowData, so the "Workflow
        // Status" column (which reads dealer_confirmation_status straight off the row) and the
        // "COF/Credit Note" column (epod_document_id/type) stayed stale after Approve/Reject until
        // some unrelated later reload. loadTrips() is the existing, established mechanism every
        // other row field is refreshed through (POD upload, COF upload, Revert POD, late-upload
        // gate approve/reject all already call it) - added here for the same reason, not a new
        // fetch mechanism.
        this.loadAlReviewQueue();
        this.loadTrips();
    }

    // ---- WEB-025: Reopen ------------------------------------------------------------------------
    onClickDealerConditionReopen = (qrow) => {
        this.setState({ dcReopenModalShow: true, dcReopenRow: qrow, dcReopenRemarks: '', dcReopenError: '', dcReopenSubmitting: false });
    }
    onChangeDcReopenRemarks = (e) => {
        var v = e.target.value;
        var maxLen = (this.state.dealerConditionOptions.max_remarks_length) || 500;
        if (v.length > maxLen) v = v.substring(0, maxLen);
        this.setState({ dcReopenRemarks: v, dcReopenError: '' });
    }
    onCancelDcReopen = () => {
        this.setState({ dcReopenModalShow: false, dcReopenRow: null, dcReopenRemarks: '', dcReopenError: '', dcReopenSubmitting: false });
    }
    onConfirmDcReopen = () => {
        var { dcReopenRow, dcReopenRemarks, dealerConditionOptions } = this.state;
        var trimmed = (dcReopenRemarks || '').trim();
        if (dealerConditionOptions.condition_change.require_reopen_remarks && !trimmed) {
            this.setState({ dcReopenError: 'Remarks are required to reopen this confirmation.' });
            return;
        }
        this.setState({ dcReopenSubmitting: true, dcReopenError: '' });
        redirectURL.post("/billing/dealerConfirmationReopen", { rowid: dcReopenRow._id, remarks: trimmed }, { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    this.setState({
                        dcReopenModalShow: false, dcReopenRow: null, dcReopenRemarks: '', dcReopenSubmitting: false, dcReopenError: '',
                        show: true, basicType: "success", basicTitle: resp.data.message || "Confirmation reopened.",
                    });
                    // Same reasoning as onAlReviewSubmitted/onReviewPodSubmitted - also refresh
                    // rowData (via the existing loadTrips()) so Workflow Status reflects the reopen
                    // immediately, not just dealerConditionQueueMap. A row that was pending_al_review
                    // drops out of the backend's alReviewQueue the instant reopenConfirmation() clears
                    // dealer_confirmation_status (dealerConfirmationService.js) - without this refresh
                    // alReviewQueueMap stays stale and the AL Review Action column keeps showing an
                    // action for a record the backend no longer considers pending review.
                    this.loadDealerConditionQueue();
                    this.loadAlReviewQueue();
                    this.loadTrips();
                } else {
                    this.setState({ dcReopenSubmitting: false, dcReopenError: (resp.data && resp.data.message) || 'Reopen failed.' });
                }
            })
            .catch((err) => {
                this.setState({ dcReopenSubmitting: false, dcReopenError: (err.response && err.response.data && err.response.data.message) || 'Reopen failed.' });
            });
    }

    // ---- Damage Image viewer ---------------------------------------------------------------------
    // Damage Files - grid column count, for ALL user types. Sends only the LR ids already loaded
    // into this grid (already scoped to this user by the existing /consignments/couriers call
    // above) - the backend re-derives ownership itself from the authenticated caller, so this is
    // purely a "which of these do you actually have damage files for" lookup, never a source of
    // authorization by itself.
    loadDamageFilesSummary = (records) => {
        var rowids = (records || []).map((r) => r._id).filter(Boolean);
        if (rowids.length === 0) return;
        redirectURL.post("/billing/dealerDamageFilesSummary", { rowids: rowids }, { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    this.setState({ damageFilesCountMap: resp.data.counts || {} });
                }
            })
            .catch(() => { /* column simply shows "-" for every row until this succeeds */ });
    }
    // Damage Files - the row's damage files are resolved ONLY through the new backend-authoritative
    // /billing/dealerDamageFiles endpoint (verifies ownership server-side for every user_type, never
    // accepts a caller-supplied S3 key). Never persisted anywhere - closing the modal just discards
    // the resolved signed URLs from React state.
    onClickViewDamageFiles = (row) => {
        if (this.state.damageFilesLoading) return;
        this.setState({
            damageFilesModalShow: true, damageFilesRow: row, damageFilesItems: [],
            damageFilesLoading: true, damageFilesError: '',
        });
        redirectURL.post("/billing/dealerDamageFiles", { rowid: row._id }, { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    var items = (resp.data.files || []).map((f) => Object.assign({}, f, {
                        ext: (f.file_name.split('.').pop() || '').toLowerCase(),
                    }));
                    this.setState({
                        damageFilesItems: items, damageFilesLoading: false,
                        damageFilesError: items.length === 0 ? 'No damage files were found for this LR.' : '',
                    });
                } else {
                    this.setState({ damageFilesLoading: false, damageFilesError: (resp.data && resp.data.message) || 'Could not load damage files.' });
                }
            })
            .catch((err) => {
                var msg = (err.response && err.response.data && err.response.data.message) || 'Could not load damage files. Please try again.';
                this.setState({ damageFilesLoading: false, damageFilesError: msg });
            });
    }
    onCloseDamageFiles = () => {
        this.setState({
            damageFilesModalShow: false, damageFilesRow: null, damageFilesItems: [],
            damageFilesLoading: false, damageFilesError: '',
        });
    }
    // Same mechanism/pattern as the existing, proven onClickViewPOD - the signed URL itself
    // already carries Content-Disposition:attachment (fileDownloader.downloadfile(), the exact
    // function /downloadPodDocument also uses), so simply opening it makes the browser download it
    // - for every file type, images included. No in-app preview branch here for the same reason
    // View POD has none.
    onClickDamageFileView = (item) => {
        if (!item.url) return;
        const newWindow = window.open(item.url, '_blank');
        if (newWindow) { newWindow.opener = null; }
    }

    // Which late-upload actions exist is decided by the backend config (epod_late_upload), never
    // by the UI. While the feature is disabled the backend returns enabled:false and the gate
    // column + action button stay hidden, so this screen looks exactly as it does today.
    loadEpodLateUploadOptions = () => {
        redirectURL.post("/billing/epodLateUploadOptions", withDeptCode({}), {
            headers: { 'Authorization': localStorage.getItem("userid") }
        })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    this.setState({
                        epodGateEnabled: resp.data.enabled === true,
                        // !== false: an older backend that doesn't send can_review must not hide the
                        // column from the AL team - the server enforces it either way.
                        epodGateCanReview: resp.data.can_review !== false,
                        epodGateActions: resp.data.approval_actions || {},
                        epodGateAllowedDays: resp.data.allowed_days,
                        // Mirrors the backend's cap so the modal's client-side check (a UX
                        // convenience only) matches what the server will actually enforce.
                        epodGateMaxRemarksLength: resp.data.max_remarks_length || 500,
                        epodOcrEligibleStates: resp.data.ocr_eligible_states || [],
                        epodOcrReviewOptions: resp.data.ocr_manual_review || {}
                    })
                }
            })
            .catch(() => {
                // Fail closed - no actions offered if the options call fails.
                this.setState({ epodGateEnabled: false, epodGateCanReview: false, epodGateActions: {}, epodOcrEligibleStates: [], epodOcrReviewOptions: {} })
            })
    }

    // Options for getOcrReviewState (workflowStatus.js) - the backend's ocr_manual_review settings
    // plus the OCR-eligible gate states, so the screen offers the AL decision on exactly the rows
    // the server accepts it for.
    ocrReviewOpts = () => Object.assign({}, this.state.epodOcrReviewOptions, { eligibleGateStates: this.state.epodOcrEligibleStates })

    // --- AL decision on an e-POD that failed OCR on its last allowed upload --------------------
    // Approve and Reject both open this modal; remarks are required unless the backend config says
    // otherwise (and the server re-checks everything, including that the row is still waiting).
    onClickOcrReview = (action, rowData) => {
        this.setState({ epodOcrReview: { row: rowData, action: action, remarks: '', error: '', submitting: false } })
    }

    onChangeOcrReviewRemarks = (e) => {
        var maxLen = ((this.state.epodOcrReviewOptions.remarks || {}).max_length) || 500
        var value = e.target.value
        if (value.length > maxLen) value = value.substring(0, maxLen)
        this.setState((prev) => ({ epodOcrReview: Object.assign({}, prev.epodOcrReview, { remarks: value, error: '' }) }))
    }

    onCancelOcrReview = () => {
        if (this.state.epodOcrReview && this.state.epodOcrReview.submitting) return
        this.setState({ epodOcrReview: null })
    }

    onConfirmOcrReview = () => {
        var m = this.state.epodOcrReview
        if (!m || m.submitting) return
        var remarksCfg = this.state.epodOcrReviewOptions.remarks || {}
        var required = m.action === 'approve' ? remarksCfg.required_on_approve !== false : remarksCfg.required_on_reject !== false
        var trimmed = (m.remarks || '').trim()
        if (required && !trimmed) {
            this.setState({ epodOcrReview: Object.assign({}, m, { error: 'Remarks are required.' }) })
            return
        }
        this.setState({ epodOcrReview: Object.assign({}, m, { submitting: true, error: '' }) })
        redirectURL.post("/billing/epodOcrReviewAction", {
            rowid: m.row._id,
            action: m.action,
            upload_seq: (m.row.epod_gate || {}).upload_seq,
            remarks: trimmed
        }, { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    this.setState({
                        epodOcrReview: null, show: true, basicTitle: resp.data.message,
                        basicType: m.action === 'reject' ? "danger" : "success",
                    })
                    this.loadTrips()
                } else {
                    this.setState({ epodOcrReview: Object.assign({}, m, { submitting: false, error: (resp.data && resp.data.message) || 'Action failed.' }) })
                }
            })
            .catch((err) => {
                var msg = (err.response && err.response.data && err.response.data.message) || 'Action failed.'
                this.setState({ epodOcrReview: Object.assign({}, m, { submitting: false, error: msg }) })
            })
    }

    // Whether "Revert POD" hides itself for a row that has already reached a terminal e-POD state
    // (Dealer Condition Clean / AL Review signed document) is decided by the backend config
    // (epod_revert_lock), never hardcoded here. Display-only, exactly like loadPodTabsConfig above -
    // see epodRevertLockConfig.js's own header for why there's no matching server-side check.
    loadEpodRevertLockOptions = () => {
        redirectURL.post("/billing/epodRevertLockOptions", {}, {
            headers: { 'Authorization': localStorage.getItem("userid") }
        })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    var cfg = resp.data.config || {};
                    this.setState({
                        epodRevertLockEnabled: cfg.enabled === true,
                        epodRevertLockOnDealerClean: cfg.lock_on_dealer_clean !== false,
                        epodRevertLockOnDealerDamage: cfg.lock_on_dealer_damage !== false,
                        epodRevertLockOnSignedDocument: cfg.lock_on_signed_document !== false,
                        epodRevertLockAppliesTo: cfg.applies_to || 'all',
                        epodCloseUpRequiresWorkflowComplete: cfg.close_up_requires_workflow_complete === true
                    })
                }
            })
            .catch(() => {
                // Fail closed to today's behavior - Revert POD stays exactly as it is now.
                this.setState({ epodRevertLockEnabled: false, epodCloseUpRequiresWorkflowComplete: false })
            })
    }

    // Feature flag + reason-modal limits for the redesigned Revert POD flow (epod_pod_revert
    // config). Fail-closed default (epodPodRevertRequireReason stays true) matches the backend's
    // own default, so the modal never lets an admin skip the reason just because this call failed.
    loadEpodPodRevertOptions = () => {
        redirectURL.post("/billing/epodPodRevertOptions", {}, {
            headers: { 'Authorization': localStorage.getItem("userid") }
        })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    var cfg = resp.data.config || {};
                    this.setState({
                        epodPodRevertEnabled: cfg.enabled === true,
                        epodPodRevertRequireReason: cfg.require_revert_reason !== false,
                        epodPodRevertMaxRemarksLength: cfg.max_remarks_length || 500
                    })
                }
            })
            .catch(() => { /* keep the fail-closed defaults already in state */ })
    }

    // True once any loaded row is on the independent dealer flow - gates the "POD Verification"
    // column so it never shows up (empty) while that flow is switched off. Memoized on the rowData
    // array identity because columnDefs are rebuilt on every render and rows can number in the
    // thousands.
    hasIndependentRows = () => {
        var rows = this.state.oRowData;
        if (this._independentRowsSrc !== rows) {
            this._independentRowsSrc = rows;
            this._independentRowsVal = Array.isArray(rows) && rows.some(isIndependentRow);
        }
        return this._independentRowsVal === true;
    }

    // Shared "is this LR's e-POD workflow actually terminal" check - the SAME definition the
    // Revert POD lock (epod_revert_lock) already uses to hide its own button, reused (not
    // duplicated) so the Closed-tab gating below can never silently drift from it.
    isEpodWorkflowTerminal = (row) => {
        return (this.state.epodRevertLockOnDealerClean && row.dealer_confirmation_status === 'closed_clean')
            || (this.state.epodRevertLockOnDealerDamage && row.dealer_confirmation_status === 'closed_damage')
            || (this.state.epodRevertLockOnSignedDocument && row.epod_signed_document_status === 'signed_uploaded')
    }

    // Closed-tab / "Close-up POD" membership. Base condition (is_submitted_pod===1 &&
    // process_status===0, set at upload time) is unchanged and always required. When
    // epod_revert_lock's close_up_requires_workflow_complete is enabled, ALSO requires the
    // dealer/AL-review workflow to have actually reached a terminal outcome - ships false
    // (today's exact behavior) until the business explicitly turns it on.
    isEpodClosedTabRow = (row) => {
        var baseClosed = row.is_submitted_pod === 1 && row.process_status === 0
        if (!baseClosed) return false
        if (!this.state.epodCloseUpRequiresWorkflowComplete) return true
        return this.isEpodWorkflowTerminal(row)
    }

    // Single action handler for every configured action. The backend re-checks that the action is
    // enabled and that upload_seq still matches, so hiding a button here is convenience, not
    // security.
    onClickEpodGateAction = (action, rowData) => {
        if (this.state.epodGateActionBusyRowId) return; // already processing a click for some row - ignore a rapid re-click
        var gate = rowData.epod_gate || {};
        this.setState({ epodGateActionBusyRowId: rowData._id });
        // AgGrid does not re-render a framework cell component just because unrelated parent state
        // changed (same reason loadAlReviewQueue redraws after alReviewQueueMap changes) - without
        // this, the button would keep looking clickable even though the click handler above is
        // already guarding against a second request.
        if (this.gridApi) this.gridApi.redrawRows();
        redirectURL.post("/billing/epodLateUploadReview", {
            rowid: rowData._id,
            action: action,
            upload_seq: gate.upload_seq,
            remarks: ""
        }, { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    // A successful Reject is still a successful API call - never a failure - but
                    // rendered with the existing red/danger alert style since the business RESULT
                    // is a rejection; a successful Approve stays green.
                    this.setState({
                        epodGateActionBusyRowId: null, show: true, basicTitle: resp.data.message,
                        basicType: action === 'reject' ? "danger" : "success",
                    })
                    this.loadTrips()
                } else {
                    this.setState({ epodGateActionBusyRowId: null, show: true, basicTitle: (resp.data && resp.data.message) || "Action failed", basicType: "danger" })
                    if (this.gridApi) this.gridApi.redrawRows();
                }
            })
            .catch((err) => {
                var msg = (err.response && err.response.data && err.response.data.message) || "Action failed";
                // No refetch on a genuine failure - nothing changed server-side, same convention
                // every other failure branch in this file already follows.
                this.setState({ epodGateActionBusyRowId: null, show: true, basicTitle: msg, basicType: "danger" })
                if (this.gridApi) this.gridApi.redrawRows();
            })
    }

    // --- Reject: mandatory-remarks confirmation modal -----------------------------------------
    // Rejection is NEVER a single click. Clicking "Reject" in the grid only gets here - the actual
    // API call happens exclusively from onConfirmEpodReject, after the admin has typed remarks and
    // pressed "Confirm Reject". Cancel (or closing the modal any other way) calls onCancelEpodReject,
    // which never talks to the backend, so the E-POD is left completely unchanged.

    onClickEpodGateReject = (rowData) => {
        this.setState({
            epodRejectModalShow: true,
            epodRejectRow: rowData,
            epodRejectRemarks: '',
            epodRejectError: '',
            epodRejectSubmitting: false
        })
    }

    onChangeEpodRejectRemarks = (e) => {
        var value = e.target.value
        // Enforced client-side too so the counter/typing experience matches the server's real
        // cap - but the server re-checks this independently and is the actual authority.
        var maxLen = this.state.epodGateMaxRemarksLength || 500
        if (value.length > maxLen) value = value.substring(0, maxLen)
        this.setState({ epodRejectRemarks: value, epodRejectError: '' })
    }

    onCancelEpodReject = () => {
        // Deliberately just resets local state - no API call, so the E-POD is untouched.
        this.setState({
            epodRejectModalShow: false,
            epodRejectRow: null,
            epodRejectRemarks: '',
            epodRejectError: '',
            epodRejectSubmitting: false
        })
    }

    onConfirmEpodReject = () => {
        var { epodRejectRow, epodRejectRemarks, epodGateMaxRemarksLength } = this.state
        var trimmed = (epodRejectRemarks || '').trim()

        // Client-side validation is a UX convenience only - the backend independently re-validates
        // (non-empty after trim, max length, action enabled, state, upload_seq) and is what
        // actually decides whether the rejection is accepted.
        if (!trimmed) {
            this.setState({ epodRejectError: 'Rejection remarks are required.' })
            return
        }
        var maxLen = epodGateMaxRemarksLength || 500
        if (trimmed.length > maxLen) {
            this.setState({ epodRejectError: 'Rejection remarks must be ' + maxLen + ' characters or fewer.' })
            return
        }
        if (!epodRejectRow) {
            this.setState({ epodRejectError: 'No e-POD selected.' })
            return
        }

        var gate = epodRejectRow.epod_gate || {}
        this.setState({ epodRejectSubmitting: true, epodRejectError: '' })
        redirectURL.post("/billing/epodLateUploadReview", {
            rowid: epodRejectRow._id,
            action: 'reject',
            upload_seq: gate.upload_seq,
            remarks: trimmed
        }, { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    // This modal only ever performs Reject - a successful call here is a
                    // successful rejection, shown with the existing red/danger alert style (never
                    // treated as an API failure - the operation itself succeeded).
                    this.setState({
                        epodRejectModalShow: false, epodRejectRow: null, epodRejectRemarks: '',
                        epodRejectError: '', epodRejectSubmitting: false,
                        show: true, basicTitle: resp.data.message, basicType: "danger"
                    })
                    this.loadTrips()
                } else {
                    // Stays open on failure (e.g. a stale upload_seq because someone re-uploaded
                    // in the meantime) so the admin can see why and re-check the record.
                    this.setState({
                        epodRejectSubmitting: false,
                        epodRejectError: (resp.data && resp.data.message) || 'Rejection failed.'
                    })
                }
            })
            .catch((err) => {
                var msg = (err.response && err.response.data && err.response.data.message) || 'Rejection failed.'
                this.setState({ epodRejectSubmitting: false, epodRejectError: msg })
            })
    }

    // getLiabilityData = (startDate) => {
    //     const { startDate: from_date, endDate: to_date } = this.getMonthDates(startDate);
    //     // console.log("from_date, to_date", from_date, to_date)
    //     let params = {
    //         "from_date": from_date,
    //         "to_date": to_date,
    //         "consigner_code": [
    //             {
    //                 "value": "all",
    //                 "label": "All"
    //             }
    //         ],
    //         "pod_status": 1,
    //         "serviceProviders": [],
    //         "is_filter_call": 0
    //     }
    //     this.loadTrips(params);
    // }

    loadTrips = () => {
        // console.log(params,"params123")
        this.setState({

            loadshow: 'show-m',
            overly: 'show-m'
        })
        var fdate = this.state.from_date //by default we are giving 1 week data 
        var todayDate = this.state.to_date
        var fdt = fdate.split("-");
        var fromdate = fdt[2] + "-" + fdt[1] + "-" + fdt[0];
        var tdt = todayDate.split("-");
        var todate = tdt[2] + "-" + tdt[1] + "-" + tdt[0];
        var transporter = this.state.flTransporter

        var params = { from_date: fdate, to_date: todayDate, consigner_code: [{ "value": "all", "label": "All" }], serviceProviders: [], is_filter_call: 0 }
        // console.log(params,"params")
        if (localStorage.getItem("supplier_code") !== "" && localStorage.getItem("supplier_code") !== undefined && localStorage.getItem("supplier_code") !== null && localStorage.getItem("supplier_code") !== "undefined") {
            params.user_code = JSON.parse(localStorage.getItem("supplier_code"))
            params.user_type = localStorage.getItem("user_type");
        }
        if (localStorage.getItem("sac_code") !== "" && localStorage.getItem("sac_code") !== undefined && localStorage.getItem("sac_code") !== null && localStorage.getItem("sac_code") !== "undefined") {
            params.sac_code = localStorage.getItem("sac_code").split(",");
        }
        if (localStorage.getItem("consignee_state") !== "" && localStorage.getItem("consignee_state") !== undefined && localStorage.getItem("consignee_state") !== null && localStorage.getItem("consignee_state") !== "undefined") {
            params.consignee_state = localStorage.getItem("consignee_state").split(",");
        }
        if (localStorage.getItem("consignee_city") !== "" && localStorage.getItem("consignee_city") !== undefined && localStorage.getItem("consignee_city") !== null && localStorage.getItem("consignee_city") !== "undefined") {
            params.consignee_state = localStorage.getItem("consignee_city").split(",");
        }
        if (transporter !== "" && transporter !== undefined && transporter !== null) {
            if (transporter.value != "") {
                params['transporter'] = [transporter.value]
            }
        }
        // SPD page: payload unchanged; LCV page: + dept_code (backend filters by it). See DEPT_CODE_MASTER_GUIDE.md
        redirectURL.post("/consignments/couriers", withDeptCode(params), {

            // redirectURL.post("/billing/trips", params,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("userid")
            }
        }).then((response) => {
            var records = response.data;
            var invalidDocketRecords = []
            records.map((item) => {
                if (item.consignment_status == "Invalid docket") {
                    return invalidDocketRecords.push(item)
                }
            })
            records = records.filter((item) => item.consignment_status != "Invalid docket")

            // console.log(invalidDocketRecords,"invalidDocketRecords")
            // var transporter = this.state.flTransporter

            //   if (this.state.shipType.value === "all") {
            //     console.log("entering")
            //       var checkData = records
            //   }
            //   else if (this.state.shipType.value === "PTL") {
            //       var checkData = records.filter((f) => ["47", "48"].includes(f.shipping_type))
            //       console.log(checkData.length, "checkdata123")
            //   }
            //   else if (this.state.shipType.value === "FTL") {
            //       var checkData = records.filter((f) => ["01", "02", "03", "04", "10", "11", "12", "14", "15", "17", "18", "21", "24", "25", "29", "30", "31", "32", "45", "46"].includes(f.shipping_type))
            //   }
            //   else {
            //       var checkData = records.filter((f) => f.shipping_type == this.state.shipType.value)
            //   }
            // console.log("checkData",checkData) 
            var checkData = records
            if (checkData.length > 0) {
                if (this.state.dataType === "pending") {
                    checkData = checkData.filter(f => (f.is_submitted_pod === "" || f.is_submitted_pod === undefined || f.is_submitted_pod === 0))
                }
                else {
                    checkData = checkData.filter(e => (e.is_submitted_pod === 1 && e.process_status === 0))
                }
            }
            const ocrVerified = records.filter(r => r.is_verified_epod === true);
            // console.log(records.length)
            var liabilityCnt = [];
            var pending = []
            var recordsarr = [];
            let gcWayBillList = []
            try {
                records.map(e => {
                    // if(e.consignment_status === "Delivered" || e.consignment_status === "DELIVERED")
                    // {
                    gcWayBillList.push({ 'label': e.gc_waybill_no, 'value': e.gc_waybill_no })
                    if (e.pod_status !== 1) {
                        liabilityCnt.push(e)
                    }
                    if (e.is_submitted_pod === "" || e.is_submitted_pod === undefined || e.is_submitted_pod === 0 || e.pod_status !== 1) {
                        pending.push(e)
                    }
                    recordsarr.push(e)
                    // }
                })
            } catch (error) {

            }
            // console.log("liabilityCnt",)
            //  console.log({recordsarr});
            // console.log("pending",pending)

            // Part K - config-driven initial view. Previously this always hardcoded rowData to
            // `pending` (with tabOne/dataType left at their "pending"-selected state-initializer
            // defaults below), regardless of user_type - the exact "always defaults to Pending"
            // behavior this task asks to make configurable. Mirrors onClickTab's own per-tab
            // filtering exactly (kept in sync deliberately), computed from the LOCAL
            // recordsarr/pending/invalidDocketRecords here because this IS the call that first
            // populates that state - this.state.oRowData does not exist yet to read from.
            var initialTab = this.state.podTabsConfig.default_tab;
            var initialTabState = { tabOne: "btn-defaultc", tabTow: "btn-defaultc", tabThree: "btn-defaultc", dataType: "total" };
            var initialRowData = recordsarr;
            if (initialTab === "pending") {
                initialTabState = { tabOne: "btn-current", tabTow: "btn-defaultc", tabThree: "btn-defaultc", dataType: "pending" };
                initialRowData = pending;
            } else if (initialTab === "closed") {
                initialTabState = { tabOne: "btn-defaultc", tabTow: "btn-current", tabThree: "btn-defaultc", dataType: "closed" };
                initialRowData = recordsarr.filter((e) => this.isEpodClosedTabRow(e));
            } else if (initialTab === "invalid_docket") {
                initialTabState = { tabOne: "btn-defaultc", tabTow: "btn-defaultc", tabThree: "btn-current", dataType: "invalid" };
                initialRowData = invalidDocketRecords;
            }

            this.setState(Object.assign({
                // shipType:this.state.shipType,
                liability_data: liabilityCnt,
                rowData: initialRowData,
                totalrecords: records,
                oRowData: recordsarr,
                pending: pending,
                invalidDocketRecords: invalidDocketRecords,
                liabilityCnt: liabilityCnt,
                gcWayBillList,
                ocrVerifiedCount: ocrVerified.length,
                loadshow: 'show-n',
                overly: 'show-n'
            }, initialTabState))
            // this.showTabView(1);
            this.loadDamageFilesSummary(records);
        })

        // {} on SPD pages (as before); { dept_codes: "LCV" } on LCV pages - same as the courier pages
        var filterKeyParams = {}
        if (getDeptCode() != '') {
            filterKeyParams.dept_codes = getDeptCode()
        }
        redirectURL.post("/consignments/getConsignmentsNewFilterKeys", filterKeyParams, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("userid")
            }
        })
            .then((resp) => {
                var transporters = resp.data.transportersList;
                let tlist = [];
                let tlistarr = [];
                try {

                    // transporters.map((t) => {
                    // 	tlistarr.push({
                    // 		"value": t.transporter_code,
                    // 		"label": t.transporter_name+" - "+t.transporter_code
                    // 	});
                    // });

                    var filterTransporters = [];
                    if (transporters.length > 0) {
                        filterTransporters.push({
                            label: "All",
                            value: ""
                        });
                        transporters.map((t) => {
                            tlistarr.push({
                                "value": t.transporter_code,
                                "label": t.transporter_name + " - " + t.transporter_code,
                            });
                        });
                    }
                    let newArray = [];
                    // Declare an empty object 
                    let totuniqueObject = {};
                    var totobjTitle;
                    // Loop for the array elements 
                    for (let i in tlistarr) {

                        // Extract the title 
                        totobjTitle = tlistarr[i]['value'];

                        // Use the title as the index 
                        totuniqueObject[totobjTitle] = tlistarr[i];
                    }

                    // Loop to push unique object into array 
                    for (var a in totuniqueObject) {
                        newArray.push(totuniqueObject[a]);
                    }
                    tlist.push({ value: "", label: "All" })
                    if (newArray.length > 0) {
                        newArray.map((item) => {
                            tlist.push(item)
                        })
                    }
                    this.setState({
                        filterTransporters: tlist,
                    });
                } catch (e) {
                    this.setState({
                        filterTransporters: [],
                    });
                }
            })
    }

    getMonthDates = (monthYear) => {
        // console.log("monthYear", monthYear)
        const [year, month] = monthYear.split('-');
        const startDate = new Date(year, month - 1, 1).toISOString().slice(0, 10);
        // const now = new Date();
        // const currentYear = now.getFullYear();
        // const currentMonth = now.getMonth() + 1;
        const daysInMonth = new Date(year, month, 0).getDate();
        const endDate = new Date(year, month - 1, daysInMonth).toISOString().slice(0, 10);

        return { startDate, endDate };
    }

    closeAlert = () => {
        this.setState({
            show: false
        });
    }

    onShowCourierTrack = async (params) => {
        console.log(params, "12345")
        if (googleAnalytics.page.enableGA) {
            let pageTitle = this.state.pageTitle;
            let eventOptions = {
                "category": pageTitle,
                "action": this.state.eventGridAction,
                "label": googleAnalytics.page.action.trackCourier,
            }
            googleAnalytics.logEvent(eventOptions);
        }
        if (params != 0) {

            await this.setState({

                detailCellRendererParams: {
                    detailGridOptions: {
                        columnDefs: [

                            {
                                headerName: "Transit Date",
                                field: "intransit_date",
                                valueGetter: function (params) {
                                    // console.log("IN onShowCourierTrack, params.data = ", typeof(params.data.intransit_date));
                                    // var intransitdate=getDDMMYYYY(params.data.intransit_date)+" "+params.data.intransit_time
                                    //    var intransitdate= params.data.intransit_date +" "+ params.data.intransit_time
                                    //    return intransitdate
                                    if ((params.data.intransit_date).includes('Z')) return getHyphenDDMMMYYYYHHMM(params.data.intransit_date)
                                    return (params.data.intransit_date)
                                },
                                filter: true,
                                resizable: true
                            },
                            {
                                headerName: "Location",
                                field: "intransit_location",
                                filter: true,
                                resizable: true
                            },
                            {
                                headerName: "Status",
                                field: "intransit_status",
                                filter: true,
                                resizable: true
                            }
                        ]
                    },
                    getDetailRowData: function (params) {
                        console.log("Step 4 ", params.data.gc_waybill_no)
                        redirectURL.post('/consignments/trackcourier',
                            { consignment_code: params.data.consignment_code }, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': localStorage.getItem("userid")
                            }
                        })
                            .then(async (response) => {
                                // console.log("Step 1 ",response.data)
                                var trackData = response.data;
                                // console.log("trackData ", trackData);
                                try {
                                    trackData.sort((a, b) => new Date(a.intransit_date) - new Date(b.intransit_date))
                                } catch (e) {
                                    trackData = []
                                }
                                // console.log("trackDataAfter ", trackData);

                                if (trackData.status == 'failure') {
                                    params.successCallback([]);
                                }
                                else {
                                    params.successCallback(trackData);
                                }

                                //console.log("Step 2 ",response.data)

                            });

                    },
                    masterDetail: true
                }
            });

            //console.log("detailCellRendererParams ", this.state.detailCellRendererParams);

        }
        //console.log("params.column.colId ", params.column)
        if (params.column.colDef.field == '_id') {
            params.node.setExpanded(!params.node.expanded);
        }
        else {

            params.node.setExpanded(false);
        }
    }

    setCounterData = counter => {

    }

    handlerStartDateTime = (event) => {
        var d = new Date(event._d);
        // console.log("d.getMonth()",d.getMonth())
        let month = d.getMonth()
        if (month <= 10) {
            month = `0${month + 1}`
        } else {
            month = `${month + 1}`
        }
        let startDate = d.getFullYear() + "-" + month
        // console.log("startDate", startDate)
        this.setState({
            startDate: startDate,
            loadshow: 'show-m',
            overly: 'show-m'
        });
        this.getLiabilityData(startDate)
    }

    hideSlideBlock = () => {
        $("#podDoc").val("")
        $("#epodDoc").val("")

        this.setState({
            delivered_date: "",
            uploadPodError: ''
        })
        // this.setState({
        //     shipment_slider: '',
        //     slider: "",
        //     slidershow: "show-n",
        //     bulkslidershow: "show-n",
        //     sliderSupportshow: 'show-n',
        //     overly: "show-n",
        //     selected_row_nodes: [],
        //     loadshow: 'show-n',
        //     slidershow: "show-n"
        // })
        document.getElementById("formBulkPOD").reset();
        document.getElementById("formPOD").reset();
        document.getElementById("formBulkSingle").reset();
    }

    onCloseSliderDiv = () => {
        $("#podDoc").val("")
        $("#epodDoc").val("")
        $("#File").val("")

        this.setState({
            manual_upload_slider: 'show-n',
            bulkMarkDeliverSlide: 'show-n',
            shipment_slider: "show-n",
            shipment_csvcontent: [],
            shipment_file: '',
            slidershow: "show-n",
            bulkslidershow: "show-n",
            sliderscanshow: "show-n",
            sliderSupportshow: 'show-n',
            overly: "show-n",
            selected_row_nodes: [],
            loadshow: 'show-n',
            multiplePodDocs: [],
            delivered_date: "",
            update_row_slider: "",
            uploadPodError: '',
        });
    };

    changeDateTimeValue = (event, currentDate, selectedDate) => {
        // console.log("event", event)
        var d = new Date(event._d);
        // var startdate = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " " + d.getHours() + ":" + ((d.getMinutes() < 10) ? "0" + d.getMinutes() : d.getMinutes()) + ":" + ((d.getSeconds() < 10) ? "0" + d.getSeconds() : d.getSeconds());
        var startdate = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
        // console.log("getHyphenDDMMMYYYYHHMM(d) ",getHyphenDDMMMYYYYHHMM(d))
        this.setState({
            delivered_date: getHyphenYYYYMMDD(d)
        });
        //let value = event.target.value;
        //this.setState({'startDate':value});
    }
    changeDateTimeGCValue = (event, currentDate, selectedDate) => {
        // console.log("event", event)
        var d = new Date(event._d);
        var startdate = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " " + d.getHours() + ":" + ((d.getMinutes() < 10) ? "0" + d.getMinutes() : d.getMinutes()) + ":" + ((d.getSeconds() < 10) ? "0" + d.getSeconds() : d.getSeconds());
        // console.log("getHyphenDDMMMYYYYHHMM(d) ",getHyphenDDMMMYYYYHHMM(d))
        this.setState({
            gc_date: getHyphenDDMMMYYYYHHMM(d)
        });
        //let value = event.target.value;
        //this.setState({'startDate':value});
    }

    changeDateTimeSCompletion = (event, currentDate, selectedDate) => {
        // console.log("event", event)
        var d = new Date(event._d);
        var startdate = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " " + d.getHours() + ":" + ((d.getMinutes() < 10) ? "0" + d.getMinutes() : d.getMinutes()) + ":" + ((d.getSeconds() < 10) ? "0" + d.getSeconds() : d.getSeconds());
        // console.log("getHyphenDDMMMYYYYHHMM(d) ",getHyphenDDMMMYYYYHHMM(d))
        this.setState({
            shipment_completion_date: getHyphenDDMMMYYYYHHMM(d)
        });
        //let value = event.target.value;
        //this.setState({'startDate':value});
    }


    changeHandler = (event) => {
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value
        })
    }

    changeManualFileHandler = async (e) => {
        if (e.target.files.length !== 0) {
            const config = {
                headers: [
                    {
                        name: 'truck_no',
                        inputName: 'truck_no',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'gc_waybill_no',
                        inputName: 'gc_waybill_no',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'gc_date',
                        inputName: 'gc_date',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'shipment_completion_date',
                        inputName: 'shipment_completion_date',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'shipping_type',
                        inputName: 'shipping_type',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'consignee_name',
                        inputName: 'consignee_name',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'consignee_pincode',
                        inputName: 'consignee_pincode',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'allowable_weight',
                        inputName: 'allowable_weight',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'per_kg_slab_rate',
                        inputName: 'per_kg_slab_rate',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'basic_trans_cost',
                        inputName: 'basic_trans_cost',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },

                ]
            }
            var data = CSVFileValidator(e.target.files[0], config)
                .then((csvData) => {
                    // console.log('csvData', csvData)
                    this.setState({
                        manual_csvcontent: csvData.data
                    });
                    let keys = Object.keys(csvData.data[0])
                    let items = ['truck_no', 'gc_waybill_no', 'gc_date', 'shipment_completion_date', 'shipping_type', 'consignee_name', 'consignee_pincode', 'allowable_weight', 'per_kg_slab_rate', 'basic_trans_cost']
                    let check = false
                    for (let i in items) {
                        if (keys.includes(items[i])) {
                        } else {
                            check = true
                            break
                        }
                    }
                    // console.log("check", check)
                    if (check) {
                        $("#uploadFile").val("")
                        // document.getElementById("appednCSVData").innerHTML = ''
                        this.setState({
                            show: true,
                            basicTitle: 'dont upload other fields',
                            basicType: 'danger'
                        });
                    } else {
                        this.setState({
                            manual_csvcontent: csvData.data
                        });
                    }
                })
                .catch(err => { })
            // console.log("e.target.files[0]",e.target.result);
            var contentList = []
            var out = new Promise(function (reject, resolve) {
                var reader = new FileReader();
                reader.onload = async function (e) {
                    var contents = await e.target.result;
                    // document.getElementById("appednCSVData").innerHTML = contents
                    resolve(contents);
                };
                if (e.target.files) {
                    var tt = reader.readAsText(e.target.files[0]);
                }
            });

            // console.log(contentList);
            this.setState({
                manual_file: e.target.files[0]
            });
            // console.log("e.target.files[0].type ", e.target.files[0]);

            if (e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
                // console.log(fileData);
                // console.log(typeof(fileData))

            }
            else {
                e.target.value = null;
                this.setState({
                    uploadFile: '',
                    file: "",
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'Please upload file having extensions .csv only.',
                });
            }

        }
    }

    setSelectedGcWayNo = (e) => {
        // console.log("item", e)
        this.setState({
            gc_way_bill_No_sel: e
        })
    }

    resetUpload = () => {
        $("#manualUploadFile").val("")
        this.setState({
            delivered_date: ""
        })
        // document.getElementById("appednCSVData").innerHTML = ''
        // this.setState({
        //     uploadDivWidth: '0%',
        //     bulkForceCloseSlide: '',
        //     bulkMarkDeliverSlide: '',
        //     showDiv: 'show-n',
        //     overly: 'show-n',
        //     file: '',
        //     shipment_slider: 'show-n'
        // });
    }

    uploadManualBulkFormHandler = (e) => {
        e.preventDefault()
        const { gc_way_bill_No_sel, manual_csvcontent } = this.state

        if (gc_way_bill_No_sel.value !== "") {
            let params = {
                gc_way_bill_No_sel: gc_way_bill_No_sel.value,
                manual_csvcontent
            }
            redirectURL.post("/consignments/uploadBulkManualData", withDeptCode(params), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("userid")
                }
            }).then(res => {
                // console.log("response", res)
                if (res.data.message === 'success') {
                    $("#manualUploadFile").val("")
                    // document.getElementById("appednCSVData").innerHTML = ''
                    this.setState({
                        manual_upload_slider: "show-n",
                        manual_csvcontent: [],
                        manual_file: '',
                        show: true,
                        basicType: 'info',
                        basicTitle: 'documents uploaded, data would be reflected after few minutes'
                    })
                }
            })
            // console.log("params", params)
        }
    }

    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", this.gridOptionsWrapper);
        this.gridColumnApi = params.columnApi;
        this.restoreUserGridState();
    };

    // Per-user grid layout: stored by the same endpoints the consignment screens use, keyed by
    // userId + screen url, so a layout saved by one user is never applied to any other user.
    restoreUserGridState = () => {
        redirectURL.post("/consignments/usergridstates", { userId: localStorage.getItem("userid"), screenurl: window.location.pathname })
            .then((resp) => {
                this.savedGridState = (resp.data && resp.data[0]) || null;
                this.applySavedGridState(true);
            })
            .catch((e) => console.log("Error restoring grid state", e));
    }

    // columnDefs are rebuilt on every render(), and AG Grid resets column state whenever it receives
    // new column definitions - so the saved column layout is re-applied on onNewColumnsLoaded as
    // well, not just once after the fetch. Sort/filter are applied only on the initial restore.
    applySavedGridState = (includeSortFilter) => {
        var saved = this.savedGridState;
        if (!saved || !this.gridApi || !this.gridColumnApi) return;
        if (saved.gridcolumns) this.gridColumnApi.setColumnState(saved.gridcolumns);
        if (saved.gridgroup) this.gridColumnApi.setColumnGroupState(saved.gridgroup);
        if (includeSortFilter === true) {
            if (saved.gridcolsort) this.gridApi.setSortModel(saved.gridcolsort);
            if (saved.gridcolfilter) this.gridApi.setFilterModel(saved.gridcolfilter);
        }
    }

    onClickSaveGridState = () => {
        var reqparams = {
            gridcolumns: this.gridColumnApi.getColumnState(),
            gridgroup: this.gridColumnApi.getColumnGroupState(),
            gridcolsort: this.gridApi.getSortModel(),
            gridcolfilter: this.gridApi.getFilterModel(),
            userId: localStorage.getItem("userid"),
            screenurl: window.location.pathname,
            screentitle: "epod screen"
        }
        this.savedGridState = reqparams;
        redirectURL.post("/consignments/saveGridStates", reqparams)
            .then(() => this.setState({ show: true, basicTitle: "Successfully saved grid layout", basicType: "success" }))
            .catch((e) => console.log("Error saving grid state", e));
    }

    onClickResetGridState = () => {
        this.gridColumnApi.resetColumnState();
        this.gridColumnApi.resetColumnGroupState();
        this.gridApi.setSortModel(null);
        this.gridApi.setFilterModel(null);
        this.savedGridState = null;
        redirectURL.post("/consignments/removeUserGridState", {
            userId: localStorage.getItem("userid"),
            screenurl: window.location.pathname,
            screentitle: "epod screen"
        })
            .then(() => this.setState({ show: true, basicTitle: "Successfully reset default grid layout", basicType: "success" }))
            .catch((e) => console.log("Error resetting grid state", e));
    }

    onCellClicked = async (e) => {
        this.setState({
            delivered_date: getHyphenYYYYMMDD(e.data.delivery_datetime),
            detailCellRendererParams: {}
        })
        if (e.colDef.field == 'gc_waybill_no') {
            const data = e.data
            // console.log("cellClicked", data)
            // if (data.manual_data) {
            await this.setState({
                detailCellRendererParams: {
                    detailGridOptions: {
                        columnDefs: [
                            {
                                headerName: "Truck No",
                                field: "truck_no",
                                filter: true,
                                resizable: true
                            },
                            {
                                headerName: "Gc WayBill No",
                                field: "gc_waybill_no",
                                filter: true,
                                resizable: true
                            },
                            {
                                headerName: "Gc Date",
                                field: "gc_date",
                                valueGetter: function (params) {
                                    try {
                                        if (params.data.gc_date !== "" && params.data.gc_date !== undefined) {
                                            return getHyphenDDMMMYYYYHHMM(params.data.gc_date)
                                        }
                                        else {
                                            return "";
                                        }
                                    } catch (error) {

                                    }
                                },
                                filter: true,
                                resizable: true
                            },
                            {
                                headerName: "Customer name",
                                field: "consignee_name",
                                filter: true,
                                resizable: true
                            },
                            {
                                headerName: "Customer Pincode",
                                field: "consignee_pincode",
                                filter: true,
                                resizable: true
                            },
                            {
                                headerName: "Allowable Weight",
                                field: "allowable_weight",
                                filter: true,
                                resizable: true
                            },
                            {
                                headerName: "Basic Trans Cost",
                                field: "basic_trans_cost",
                                filter: true,
                                resizable: true
                            },
                            {
                                headerName: "Per Kg Slab Rate",
                                field: "per_kg_slab_rate",
                                filter: true,
                                resizable: true
                            },
                            {
                                headerName: "Shipping Type",
                                field: "shipping_type",
                                filter: true,
                                resizable: true
                            }
                        ]
                    },
                    getDetailRowData: function (params) {
                        // console.log("Step 4 ", data)
                        let req = {
                            gc_waybill_no: data.gc_waybill_no
                        }
                        redirectURL.post('/consignments/getManualCourierCons', req, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': localStorage.getItem("userid")
                            }
                        }).then(async (response) => {
                            // console.log("Step 1 ",response.data)
                            var manualData = response.data;
                            // console.log("manualData ", manualData);
                            try {

                            } catch (e) {
                                manualData = []
                            }
                            // console.log("manualDataAfter ", manualData);

                            if (manualData.length == 0) {
                                params.successCallback([]);
                            }
                            else {
                                params.successCallback(manualData);
                            }
                            //console.log("Step 2 ",response.data)	
                        });
                    },
                    masterDetail: true
                }
            });
            //console.log("detailCellRendererParams ", this.state.detailCellRendererParams);
            //console.log("params.column.colId ", params.column)
            if (e.column.colDef.field == 'gc_waybill_no') {
                e.node.setExpanded(!e.node.expanded);
            }
            else {
                e.node.setExpanded(false);
            }
            // }
        }

        if (e.colDef.field == 'view') {
            // console.log(e.data,"3214")
            this.setState({
                update_row_slider: "slider-translate-30p",
                overly: "show-m",
                row_data: e.data,
                errMsg: 'd-none',
                transit_data_for_update: "",
                status_for_update: "",
                delivered_date_for_update: "",
                show_delivered_date: false,
                gc_row_date: moment.parseZone(e.data.gc_date).format("YYYY-MM-DD HH:mm:ss")
            })
            $("#location_for_update").val("")
            $('#epodDocforupdate').val("")
        }
    }
    changeFileHandler = (event) => {
        // console.log("event.target.files[0] ", event.target.files[0])
        this.setState({
            epodDoc: event.target.files[0]

        })
    }

    changeBulkFileSaveCode = (event) => {
        const bulkFiles = Array.prototype.slice.call(event.target.files)
        //  console.log("File",File)
        this.setState({
            uFile: event.target.files[0],
        })

    }
    changeBulkFileHandler = e => {
        const bulkFiles = Array.prototype.slice.call(e.target.files)
        try {
            var multiplePodNames = bulkFiles.map(e => {
                let [name, date] = e.name.split("_")
                date = date.split(".")[0]
                //  console.log("name", name, "\n date",date)
                return {
                    'gc_waybill_no': name,
                    'delivered_date': date
                }
            })
        }
        catch (e) {
            this.setState({
                show: true,
                basicTitle: "Please give file name as mentioned.",
                basicType: "warning"
            })
            // console.log("error",e)
            multiplePodNames = []
        }
        // console.log("multiplePodNames",multiplePodNames)
        if (bulkFiles.length > 0) {
            this.setState({
                multiplePodDocs: bulkFiles,
                multipleFiles: e.target.files,
                multiplePodNames
            })
        }
        // console.log("bulkUploadFiles", bulkFiles)
    }

    onClickUploadManualData = () => {
        this.setState({
            manual_upload_slider: "slider-translate-40p",
            overly: "show-m",
        })
    }
    // onClickViewPOD = (e) => {
    //     //  console.log("documnent_view", e)
    //     let params = {
    //         pod_document : e.data.pod_document
    //     }
    //     //  console.log("params",params)
    //     redirectURL.post("/billing/downloadPodDocument", params,{
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': localStorage.getItem("userid")
    //           }
    //       }).then(res =>{
    //          console.log("response", res)
    //         download(res.data, e.data.pod_document)
    //     }).catch(function(error){
    //         //  console.log(error);
    //     })
    // }
    onClickViewPOD = (e) => {
        let params = {
            pod_document: e.data.pod_document,
            // Optional - only used server-side for best-effort "POD Viewed" activity logging
            // (epodActivityLogService.logPodViewed). Does not change this endpoint's existing
            // behavior in any way if absent.
            rowid: e.data._id
        };

        redirectURL.post("/billing/downloadPodDocument", params, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("userid")
            }
        }).then(res => {
            console.log("response", res);
            const fileUrl = res.data.url;
            const newWindow = window.open(fileUrl, '_blank');
            if (newWindow) {
                newWindow.opener = null;
            }
        }).catch(error => {
            console.error(error);
        });
    }


    setBulkUploadEpod = () => {
        let rownodes = this.gridApi.getSelectedRows();
        if (rownodes.length > 1) {
            this.setState({
                rownode: [],
                selected_row_nodes: rownodes,
                bulkslidershow: "slider-translate-40p", // slide30
                overly: "show-m",
                loadshow: 'show-n'
            })
        } else {
            this.setState({
                show: true,
                basicTitle: "Please Select multiple rows.",
                basicType: "info"
            })
        }
        // console.log("rowNodes", rownodes)
    }
    setBulkUploadScan = () => {
        let rownodes = this.gridApi.getSelectedRows();
        // if (rownodes.length > 0) {
        this.setState({
            rownode: [],
            selected_row_nodes: rownodes,
            sliderscanshow: "slider-translate-40p", // slide30
            overly: "show-m",
            loadshow: 'show-n'
        })
        // }
        //  else {
        //     this.setState({
        //         show: true,
        //         basicTitle: "Please Select multiple rows.",
        //         basicType: "info"
        //     })
        // }
        // console.log("rowNodes", rownodes)
    }



    uploadDocument = (event) => {
        event.preventDefault();
        if (this.state.uploadPodSubmitting) return; // already processing a click - ignore a rapid re-click/double-submit
        const { delivered_date, epodDoc, selected_row_nodes, multiplePodDocs, multiplePodNames, rownode, multipleFiles } = this.state
        if (delivered_date == "") {
            this.setState({
                show: true,
                basicType: "warning",
                basicTitle: "Please select delivered date",
                delivered_date: "",
                epodDoc: ""

            })
        }
        else {
            if (rownode.length > 0) { // for single pod upload

                var rowid = this.state.rownode[0]._id;
                var rownodes = this.state.rownode;
                const formData = new FormData();
                formData.append("podDoc", epodDoc);
                formData.append("delivered_date", delivered_date);
                formData.append("rowid", rowid);
                formData.append("rownodes", JSON.stringify(rownodes));
                //    console.log("FormData ", formData);
                this.setState({ uploadPodError: '', uploadPodSubmitting: true })
                redirectURL.post("/billing/savepoddoc", formData, { headers: { 'Authorization': localStorage.getItem("userid") } })
                    .then((resp) => {
                        if (resp.data.status == 'success') {
                            document.getElementById("formBulkPOD").reset();
                            document.getElementById("formPOD").reset();
                            this.setState({
                                selected_row_nodes: [],
                                show: true,
                                epodDoc: [],
                                slider: 'show-n',
                                basicTitle: "Success.",
                                basicType: "success",
                                delivered_date: "",
                                slidershow: "", // slide30
                                overly: "show-n",
                                loadshow: 'show-n',
                                uploadPodError: '',
                                uploadPodSubmitting: false
                            })
                            // Refetch with whatever filters/tab are already applied instead of a
                            // full page reload, so the grid, tab counts and the OCR columns pick up
                            // this upload immediately.
                            this.loadTrips()
                        } else {
                            // Keep the slider open exactly as the admin left it (file/date still
                            // filled in) and surface the failure inline there only - no global
                            // SweetAlert, no reload, no form reset. message is occasionally a raw
                            // Error object from the backend's catch-all handler, not a string, so
                            // guard against rendering that directly.
                            var failMsg = (typeof resp.data.message === 'string' && resp.data.message) || 'Upload failed. Please try again.'
                            this.setState({
                                uploadPodError: failMsg,
                                uploadPodSubmitting: false,
                                loadshow: 'show-n'
                            })
                        }
                    })
                    .catch((err) => {
                        var backendMsg = err.response && err.response.data && err.response.data.message
                        var msg = (typeof backendMsg === 'string' && backendMsg) || 'Upload failed. Please try again.'
                        this.setState({ uploadPodError: msg, uploadPodSubmitting: false, loadshow: 'show-n' })
                    })
            }
            else if (selected_row_nodes.length > 0) {  // for bulk multiple pod uploads
                //   console.log('selected_row_nodes', selected_row_nodes)
                //   console.log('multiplePodDocs', multiplePodDocs)
                //   console.log('multiplePodNames', multiplePodNames)
                var multiplePodNamesarr = [];
                if (multiplePodNames.length > 0) {
                    multiplePodNames.map((itm) => {
                        multiplePodNamesarr.push(itm.gc_waybill_no)
                    })
                }
                let matched = false
                let otpt
                if (multiplePodNamesarr.length > 0) {
                    otpt = selected_row_nodes.map((e, i) => {
                        //  console.log("e.gc_waybill_no ", e.gc_waybill_no)
                        //  console.log("multiplePodNames[i].gc_waybill_no ", multiplePodNamesarr.indexOf(e.gc_waybill_no))
                        if (multiplePodNamesarr.indexOf(e.gc_waybill_no) >= 0) {
                            matched = true
                        } else {
                            return false
                        }
                    })
                }
                //   console.log("otpt", otpt)
                if (otpt.includes(false) === true) {
                    this.setState({
                        show: true,
                        basicTitle: "gc_waybill_no should match.",
                        basicType: "info"
                    })
                } else {
                    let rowid = this.state.selected_row_nodes.map(e => e._id);
                    // console.log("rowid", rowid)
                    if (this.state.selected_row_nodes.length > 0) {
                        var selnodes = this.state.selected_row_nodes;
                    }
                    else {
                        var selnodes = [];
                    }
                    const formData = new FormData();
                    formData.append("multiplePodDocs", JSON.stringify(multiplePodDocs));
                    formData.append("delivered_date", JSON.stringify(delivered_date));
                    formData.append("multiplePodNames", JSON.stringify(multiplePodNames));
                    formData.append("rowid", JSON.stringify(rowid));
                    formData.append("rownodes", JSON.stringify(selnodes));
                    //  console.log("multipleFiles ", multipleFiles);

                    if (multipleFiles.length > 1) {
                        for (let i = 0; i < multipleFiles.length; i++) {
                            formData.append('files', multipleFiles[i]);
                        }

                        var check = true
                        selected_row_nodes.map(e => {
                            if (e.consignment_status == "In Transit") {
                                check = false
                            }
                        })
                        if (check == true) {
                            this.setState({ uploadPodSubmitting: true })
                            redirectURL.post("/billing/saveMultipledocs", formData, { headers: { 'Authorization': localStorage.getItem("userid") } })
                                .then((resp) => {
                                    console.log("response", resp.data)
                                    if (resp.data.message == "successs") {
                                        // $("#podDoc").val("");
                                        // document.getElementById("podDoc").reset()
                                        this.setState({
                                            selected_row_nodes: [],
                                            multiplePodDocs: [],
                                            multiplePodNames: [],
                                            show: true,
                                            basicTitle: "Success.",
                                            basicType: "success",
                                            delivered_date: "",
                                            bulkslidershow: "",
                                            overly: 'show-n',
                                            loadshow: 'show-n',
                                            slider: 'show-n',
                                            uploadPodSubmitting: false
                                        })
                                        // Existing full-reload pattern for this bulk path (predates this
                                        // change) - left as-is rather than switched to loadTrips(), since
                                        // it already delivers fresh data and changing an established bulk
                                        // flow carries more regression risk than benefit here.
                                        window.location.reload();
                                    }
                                    else {
                                        this.setState({
                                            show: true,
                                            basicTitle: "Invalid GC Waybill Number",
                                            basicType: "info",
                                            uploadPodSubmitting: false
                                        })
                                    }


                                })
                                .catch((err) => {
                                    // Previously no .catch() at all here - a network/HTTP failure left
                                    // the slider silently stuck with no feedback and no way to retell it
                                    // succeeded or failed. Mirrors the single-upload path's own catch
                                    // handler - no reload, no false success, slider stays open for retry.
                                    var backendMsg = err.response && err.response.data && err.response.data.message
                                    var msg = (typeof backendMsg === 'string' && backendMsg) || 'Upload failed. Please try again.'
                                    this.setState({ show: true, basicTitle: msg, basicType: "danger", uploadPodSubmitting: false })
                                })
                        } else {
                            this.setState({
                                show: true,
                                basicTitle: "Cannot upload epods for intransit consignments",
                                basicType: "info"
                            })
                        }

                    } else {
                        this.setState({
                            show: true,
                            basicTitle: "For Multiple upload only use this Feature",
                            basicType: "info"
                        })

                    }
                }

            }
        }
    }
    uploadScanCode = (event) => {
        event.preventDefault();
        const { delivered_date, podDoc, selected_row_nodes, multiplePodDocs, multiplePodNames, rownode, singleFiles } = this.state

        // if (rownode.length > 0) { // for single pod upload

        // var rowid = this.state.rownode[0]._id;
        // var rownodes = this.state.rownode;
        var uFile = this.state.uFile;

        const formData = new FormData();
        formData.append("uFile", uFile);
        formData.append("delivered_date", delivered_date);
        // formData.append("rowid", rowid);
        // formData.append("rownodes", JSON.stringify(rownodes));
        //   console.log("FormData ", formData);
        redirectURL.post("/billing/savescancode", formData)
            .then((resp) => {
                if (resp.data.status == 'success') {
                    document.getElementById("formBulkSingle").reset();
                    // document.getElementById("formPOD").reset();
                    this.setState({
                        selected_row_nodes: [],
                        overly: 'show-n',
                        loadshow: 'show-n',
                        show: true,
                        basicTitle: "Success",
                        basicType: "success",
                        delivered_date: ""
                    })
                }
                // window.location.reload();
            })
    }
    onClickHideAll = () => {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            sliderForceCloseTranslate: '',
            sliderMarkDeliverTranslate: "",
            bulkPrioritySlide: "",
            bulkForceCloseSlide: "",
            bulkMarkDeliverSlide: "",
            bulkslidershow: "",
            sliderscanshow: "",
            slidershow: "",
            delivered_date: "",
            update_row_slider: '',
            status_for_update: '',
            transit_data_for_update: '',
        });
        $("#location_for_update").val("")
        $("#epodDocforupdate").val("")
        document.getElementById("formPOD").reset();
        document.getElementById("formBulkPOD").reset();
        document.getElementById("formBulkSingle").reset();

    }



    onClickUploadPOD = (rownode) => {
        // console.log("rownode",rownode)
        this.setState({
            slidershow: "slider-translate-40p", // slide30
            overly: "show-m",
            rownode: [rownode.data],
            uploadPodError: ''
        });
    }
    // --- Revert POD: mandatory-reason confirmation modal ---------------------------------------
    // Clicking "Revert POD" in the grid only opens this modal now - the actual API call happens
    // exclusively from onConfirmPodRevert, after the admin has typed a reason (when
    // epodPodRevertRequireReason is true) and pressed "Confirm Revert". Cancel (or closing the
    // modal any other way) calls onCancelPodRevert, which never talks to the backend, so the
    // e-POD is left completely unchanged. Mirrors onClickEpodGateReject/onConfirmEpodReject above
    // exactly, including staying open (with the server's message) on failure rather than
    // silently reloading the grid either way, which is what this used to do.
    onClickRevertPOD = (rownode) => {
        this.setState({
            epodPodRevertModalShow: true,
            epodPodRevertRow: rownode.data,
            epodPodRevertReason: '',
            epodPodRevertError: '',
            epodPodRevertSubmitting: false
        })
    }

    onChangePodRevertReason = (e) => {
        var value = e.target.value
        var maxLen = this.state.epodPodRevertMaxRemarksLength || 500
        if (value.length > maxLen) value = value.substring(0, maxLen)
        this.setState({ epodPodRevertReason: value, epodPodRevertError: '' })
    }

    onCancelPodRevert = () => {
        // Deliberately just resets local state - no API call, so the e-POD is untouched.
        this.setState({
            epodPodRevertModalShow: false, epodPodRevertRow: null, epodPodRevertReason: '',
            epodPodRevertError: '', epodPodRevertSubmitting: false
        })
    }

    onConfirmPodRevert = () => {
        var { epodPodRevertRow, epodPodRevertReason, epodPodRevertRequireReason, epodPodRevertMaxRemarksLength } = this.state
        var trimmed = (epodPodRevertReason || '').trim()

        // Client-side validation is a UX convenience only - the backend independently re-validates
        // (reason required/length, feature enabled, an active POD to revert) and is what actually
        // decides whether the revert is accepted.
        if (epodPodRevertRequireReason && !trimmed) {
            this.setState({ epodPodRevertError: 'A revert reason is required.' })
            return
        }
        var maxLen = epodPodRevertMaxRemarksLength || 500
        if (trimmed.length > maxLen) {
            this.setState({ epodPodRevertError: 'Revert reason must be ' + maxLen + ' characters or fewer.' })
            return
        }
        if (!epodPodRevertRow) {
            this.setState({ epodPodRevertError: 'No e-POD selected.' })
            return
        }

        this.setState({ epodPodRevertSubmitting: true, epodPodRevertError: '' })
        redirectURL.post("/billing/revertepoddata", {
            consignment_code: epodPodRevertRow.consignment_code,
            revert_reason: trimmed
        }, { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                if (resp.data && resp.data.status === 'success') {
                    this.setState({
                        epodPodRevertModalShow: false, epodPodRevertRow: null, epodPodRevertReason: '',
                        epodPodRevertError: '', epodPodRevertSubmitting: false, rownode: [],
                        overly: 'show-n', loadshow: 'show-n',
                        show: true, basicTitle: resp.data.message || "Success", basicType: "success",
                    })
                    this.loadTrips()
                } else {
                    // Stays open on failure so the admin can see why, same pattern as onConfirmEpodReject.
                    this.setState({
                        epodPodRevertSubmitting: false,
                        epodPodRevertError: (resp.data && resp.data.message) || 'Revert failed.'
                    })
                }
            })
            .catch((err) => {
                var msg = (err.response && err.response.data && err.response.data.message) || 'Revert failed.'
                this.setState({ epodPodRevertSubmitting: false, epodPodRevertError: msg })
            })
    }

    // --- COF Note upload (Transporter/LSP) -----------------------------------------------------
    // Reuses Action 19's EXISTING /billing/alReviewDocumentSignedUpload endpoint unchanged - no new
    // API. The backend independently re-validates: caller is the LR's own transporter
    // (isUploadAuthorized), a COF/Credit Note record actually exists for this LR
    // (resolveGeneratedDocument), and the signed-upload window hasn't expired - this modal is
    // convenience only, never the source of truth.
    onClickUploadCofNote = (rowData) => {
        this.setState({
            cofUploadModalShow: true, cofUploadRow: rowData, cofUploadFile: null,
            cofUploadError: '', cofUploadSubmitting: false
        })
    }
    onCancelCofUpload = () => {
        // Deliberately just resets local state - no API call, so the e-POD is untouched.
        this.setState({
            cofUploadModalShow: false, cofUploadRow: null, cofUploadFile: null,
            cofUploadError: '', cofUploadSubmitting: false
        })
    }
    onChangeCofFile = (e) => {
        this.setState({ cofUploadFile: (e.target.files && e.target.files[0]) || null, cofUploadError: '' })
    }
    onConfirmCofUpload = () => {
        var { cofUploadRow, cofUploadFile } = this.state
        if (!cofUploadFile) { this.setState({ cofUploadError: 'Please select a file to upload.' }); return }
        this.setState({ cofUploadSubmitting: true, cofUploadError: '' })
        var formData = new FormData()
        formData.append('rowid', cofUploadRow._id)
        formData.append('signed_document', cofUploadFile)
        redirectURL.post("/billing/alReviewDocumentSignedUpload", formData, {
            headers: { 'content-type': 'multipart/form-data', 'Authorization': localStorage.getItem("userid") }
        })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    this.setState({
                        cofUploadModalShow: false, cofUploadRow: null, cofUploadFile: null,
                        cofUploadSubmitting: false, cofUploadError: '',
                        show: true, basicTitle: resp.data.message || "COF Note uploaded successfully.", basicType: "success",
                    })
                    // Refreshes the grid so epod_signed_document_status flips to 'signed_uploaded' -
                    // the column switches to "View COF Note" and Revert POD hides itself for this
                    // row (isEpodWorkflowTerminal already reads this same field).
                    this.loadTrips()
                } else {
                    this.setState({ cofUploadSubmitting: false, cofUploadError: (resp.data && resp.data.message) || 'Upload failed.' })
                }
            })
            .catch((err) => {
                var msg = (err.response && err.response.data && err.response.data.message) || 'Upload failed.'
                this.setState({ cofUploadSubmitting: false, cofUploadError: msg })
            })
    }
    onClickViewCofNote = (rowData) => {
        redirectURL.post("/billing/alReviewDocumentSignedDownload", { rowid: rowData._id }, {
            headers: { 'Authorization': localStorage.getItem("userid") }
        })
            .then((resp) => {
                if (resp.data && resp.data.status === "success" && resp.data.url) {
                    const newWindow = window.open(resp.data.url, '_blank')
                    if (newWindow) { newWindow.opener = null }
                } else {
                    this.setState({ show: true, basicTitle: (resp.data && resp.data.message) || 'You are not authorized to view this document.', basicType: "danger" })
                }
            })
            .catch((err) => {
                var msg = (err.response && err.response.data && err.response.data.message) || 'Unable to open the document.'
                this.setState({ show: true, basicTitle: msg, basicType: "danger" })
            })
    }

    handlerStartDeliveryDateTime = (event, currentDate, selectedDate) => {
        var d = new Date(event._d);

        var startdate = d.getFullYear() + "-" + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) + "-" + (d.getDate() < 10 ? "0" + d.getDate() : d.getDate())
        if (this.state.to_date != "" && startdate > this.state.to_date) {
            this.setState({
                show: true,
                basicTitle: 'Start date should be less than End date',
                basicType: "danger",
                loadshow: 'show-n',
                startDate: "",
            })
        }
        else {
            this.setState({
                from_date: startdate
            });
        }
    }
    handlerEndDeliveryDateTime = (event, currentDate, selectedDate) => {
        var d = new Date(event._d);
        var edate = d.getFullYear() + "-" + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) + "-" + (d.getDate() < 10 ? "0" + d.getDate() : d.getDate())
        if (this.state.from_date != "" && edate < this.state.from_date) {
            this.setState({
                show: true,
                basicTitle: 'End date should be greater than Start date',
                basicType: "danger",
                loadshow: 'show-n',
                endDate: "",
            })
        }
        else {
            this.setState({
                to_date: edate
            });
        }
    }
    onChangeShipType(shipType) {
        if (this.state.tabThree != "btn-current") {
            var oRowData = this.state.oRowData;
        }
        else {
            var oRowData = this.state.invalidDocketRecords;
        }

        if (shipType.value === "all") {
            var checkData = oRowData
        }
        else if (shipType.value === "PTL") {
            var checkData = oRowData.filter((f) => ["47", "48"].includes(f.shipping_type))
        }
        else if (shipType.value === "FTL") {
            var checkData = oRowData.filter((f) => ["01", "02", "03", "04", "10", "11", "12", "14", "15", "17", "18", "21", "24", "25", "29", "30", "31", "32", "45", "46"].includes(f.shipping_type))
        }
        else if (shipType.value === "ODC") {
            var checkData = oRowData.filter((f) => ["00", "06"].includes(f.shipping_type))
        }
        else {
            var checkData = oRowData.filter((f) => f.shipping_type == shipType.value)
        }
        // console.log("checkData",checkData)       
        if (checkData.length > 0) {
            if (this.state.dataType === "pending") {
                checkData = checkData.filter(f => (f.is_submitted_pod === "" || f.is_submitted_pod === undefined || f.is_submitted_pod === 0))
            }
            else if (this.state.dataType === "invalid") {
                checkData = checkData
            }
            else {
                checkData = checkData.filter(e => (e.is_submitted_pod === 1 && e.process_status === 0))
            }
        }
        this.setState({
            shipType: shipType,
            rowData: checkData
        })
    }

    newFilter = (filterType, selOption) => {
        console.log(filterType, selOption, "check")
        this.setState({ [filterType]: selOption });
    }

    submitTransporterType = (event) => {
        event.preventDefault();
        this.setState({
            overly: "show-m",
            loadshow: "show-m",
            tabOne: "btn-current",
            tabTow: "btn-defaultc",
            tabThree: "btn-defaultc",
            shipType: { label: "All", value: "all" },
            dataType: "pending"
        })
        var fromdate = this.state.from_date
        var todate = this.state.to_date
        var transporter = this.state.flTransporter
        // var shipType = this.state.shipType

        if (!["", undefined].includes(fromdate) && !["", undefined].includes(todate)) {
            // this.setState({
            // 	from_date: fromdate,
            // 	to_date: todate,
            //     // shipType: shipType,
            // 	//loadshow: 'show-m'
            // });
            this.loadTrips()
        }


    }
    // AL_ADMIN-only workflow counters: counter key -> STATUS_LABELS entry it counts. Matching is
    // done on the same resolved label the Workflow Status column shows, so counter == grid rows.
    alAdminCounters = {
        late_al: STATUS_LABELS.late_upload_pending,
        pending_dealer: STATUS_LABELS.awaiting_dealer_review,
        awaiting_al: STATUS_LABELS.awaiting_al_review,
    }

    // Notch that points down from the bottom edge of the counter card (outside it) for the selected counter.
    renderCounterNotch = (key) => this.state.dataType === key ? (
        <span style={{ position: 'absolute', left: '50%', bottom: '-26px', marginLeft: '-9px', width: '18px', height: '18px',
            background: '#fff', borderRight: '1px solid #ddd', borderBottom: '1px solid #ddd', transform: 'rotate(45deg)', zIndex: 2 }} />
    ) : null

    isAlAdmin = () => String(localStorage.getItem('roles') || '').indexOf('AL_ADMIN') >= 0
    getAlAdminCounterRows = (key) => {
        var target = this.alAdminCounters[key];
        return (this.state.oRowData || []).filter(row =>
            getWorkflowDisplayStatus(row, { ocrEligibleGateStates: this.state.epodOcrEligibleStates, ocrReview: this.ocrReviewOpts() }).text === target.text);
    }

    onClickTab(oVal) {
        //  console.log(this.state.oRowData.length);
        if (this.alAdminCounters[oVal]) {
            this.setState({
                tabOne: "btn-defaultc",
                tabTow: "btn-defaultc",
                tabThree: "btn-defaultc",
                rowData: this.getAlAdminCounterRows(oVal),
                shipType: { label: "All", value: "all" },
                dataType: oVal
            })
            return;
        }
        // Part K - "Total PODs" reuses this same existing onClickTab mechanism rather than a
        // second implementation; no tab button is highlighted (Total isn't one of the three
        // Pending/Closed/Invalid Docket buttons), full unfiltered oRowData is shown.
        if (oVal === "total") {
            this.setState({
                tabOne: "btn-defaultc",
                tabTow: "btn-defaultc",
                tabThree: "btn-defaultc",
                rowData: this.state.oRowData,
                shipType: { label: "All", value: "all" },
                dataType: oVal
            })
        }
        if (oVal === "pending") {
            let data = [];
            // console.log("data",data)
            if (this.state.oRowData.length > 0) {
                data = this.state.oRowData.filter((f) => (f.is_submitted_pod === "" || f.is_submitted_pod === undefined || f.is_submitted_pod === 0))
            }
            // console.log("data",data)
            // if(this.state.shipType.value !== "all")
            // {
            //     if(this.state.shipType.value === "PTL")
            //     {
            //          data  = data.filter((f)=>["47","48"].includes(f.shipping_type))
            //     }
            //     else 
            //     {
            //         data  = data.filter((f)=>f.shipping_type === this.state.shipType.value)

            //     }
            // }

            // console.log("data",data)
            this.setState({
                tabOne: "btn-current",
                tabTow: "btn-defaultc",
                tabThree: "btn-defaultc",
                rowData: data,
                shipType: { label: "All", value: "all" },
                dataType: oVal
            })
        }
        if (oVal === "closed") {
            let data = [];
            if (this.state.oRowData.length > 0) {
                data = this.state.oRowData.filter(e => this.isEpodClosedTabRow(e))
            }
            // if(this.state.shipType.value !== "all")
            // {
            //     if(this.state.shipType.value === "PTL")
            //     {
            //          data  = data.filter((f)=>["47", "48"].includes(f.shipping_type))
            //     }
            //     else 
            //     {
            //         data  = data.filter((f)=>f.shipping_type === this.state.shipType.value)

            //     }
            // }

            this.setState({
                tabOne: "btn-defaultc",
                tabTow: "btn-current",
                tabThree: "btn-defaultc",
                rowData: data,
                totalclosedpods: data,
                shipType: { label: "All", value: "all" },
                dataType: oVal
            })
        }
        if (oVal === "invalid") {
            let data = [];
            if (this.state.oRowData.length > 0) {
                data = this.state.oRowData.filter((f) => (f.is_submitted_pod === "" || f.is_submitted_pod === undefined || f.is_submitted_pod === 0))
            }
            // if(this.state.shipType.value !== "all")
            // {
            //     if(this.state.shipType.value === "PTL")
            //     {
            //          data  = data.filter((f)=>["47","48"].includes(f.shipping_type))
            //     }
            //     else 
            //     {
            //         data  = data.filter((f)=>f.shipping_type === this.state.shipType.value)

            //     }
            // }
            this.setState({
                tabOne: "btn-defaultc",
                tabTow: "btn-defaultc",
                tabThree: "btn-current",
                rowData: this.state.invalidDocketRecords,
                shipType: { label: "All", value: "all" },
                dataType: oVal
            })
        }
        if (oVal === "verified") {
            let data = [];
            if (this.state.oRowData.length > 0) {
                data = this.state.oRowData.filter(e => e.is_verified_epod === true);
            }
            this.setState({
                tabOne: "btn-defaultc",
                tabTow: "btn-current",
                tabThree: "btn-defaultc",
                rowData: data,
                dataType: oVal
            });
        }

    }

    changeFileHandlerForupdate = (event) => {
        // console.log("event.target.files[0] ", event.target.files[0])
        this.setState({
            epodDoc: event.target.files[0]

        })
    }

    onUpdateConsignmentDetails = (e) => {
        e.preventDefault()
        // Commented as per the naveen's call with SAFE EXPRESS --uncommented on 14/08/24 as transit_data_for_update is required
        if (this.state.transit_data_for_update != '' && this.state.errMsg == "d-none") {
            // if (this.state.errMsg == "d-none") {
            if (!["", undefined, "undefined", null].includes(this.state.status_for_update)) {
                if (this.state.status_for_update.value == 'Delivered') {
                    if (this.state.delivered_date_for_update != "") {
                        var params = {
                            "consignment_status": this.state.status_for_update.value,
                            "delivery_datetime": this.state.delivered_date_for_update,
                            'delivery_station': '',
                            // 'last_process_on': new Date(),
                            'last_date': this.state.transit_data_for_update,
                            'last_location': $("#location_for_update").val(),
                            'last_status': this.state.status_for_update.value,
                            'row_data': this.state.row_data,
                        }
                        var rownode = [this.state.row_data]
                        var rowid = rownode[0]._id;
                        var rownodes = rownode;
                        const formData = new FormData();
                        formData.append("podDoc", this.state.epodDoc);
                        formData.append("delivered_date", this.state.delivered_date_for_update.split(" ")[0]);
                        formData.append("rowid", rowid);
                        formData.append("rownodes", JSON.stringify(rownodes));
                        console.log(formData, "formData")
                        redirectURL.post("/billing/savepoddoc", formData, {
                            headers: {
                                'content-type': 'multipart/form-data',
                                'Authorization': localStorage.getItem("userid")
                            }
                        })
                            .then((resp) => {
                                console.log(resp.data, "5001_checking")
                                if (resp.data.status == 'success') {
                                    $("#epodDocforupdate").val("")
                                }
                            })
                    }
                    else {
                        this.setState({
                            show: true,
                            basicType: 'danger',
                            basicTitle: 'Please Select Delivery Date'
                        })
                    }
                }
                else {
                    var params = {
                        "consignment_status": this.state.status_for_update.value,
                        'delivery_station': '',
                        // 'last_process_on': new Date(),
                        'last_date': this.state.transit_data_for_update,
                        'last_location': $("#location_for_update").val(),
                        'last_status': this.state.status_for_update.value,
                        'row_data': this.state.row_data
                    }
                }

                this.setState({
                    loadshow: 'show-m',
                    overly: 'show-m'
                })
                console.log(params, "params")
                redirectURL.post("/consignments/updateConsignmetsData", params).then(resposne => {
                    console.log(resposne.data)
                    if (resposne.data.status == 'success') {
                        this.setState({
                            show: true,
                            basicType: 'success',
                            basicTitle: 'Data Updateded Successfully',
                            transit_data_for_update: '',
                            status_for_update: '',
                            delivered_date_for_update: '',
                            loadshow: 'show-n',
                            overly: 'show-n',
                            update_row_slider: '',
                            show_delivered_date: false,
                        })
                        $("#location_for_update").val("")
                        window.location.reload();
                        // this.componentDidMount()
                    }
                })

            }
            else {
                this.setState({
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'Please Select Status'
                })
            }
        }
        else {
            this.setState({
                show: true,
                basicType: 'danger',
                basicTitle: 'Please Select Valid Transit Date'
            })
        }

    }

    handlerTransitDateTime = (event, currentDate, selectedDate) => {
        var d = new Date(event._d);
        var date = moment.parseZone(new Date(d)).format("YYYY-MM-DD HH:mm:ss")
        //console.log(date,"date")
        if (new Date(date.split(" ")[0]) >= new Date(this.state.gc_row_date.split(" ")[0])) {
            this.setState({
                errMsg: 'd-none',
                transit_data_for_update: date,
            })
        }
        else {
            this.setState({
                errMsg: 'd-block',
                transit_data_for_update: date
            })
        }
    }

    handlerUpdateDeliveredDateTime = (event, currentDate, selectedDate) => {
        var d = new Date(event._d);
        var date = moment.parseZone(new Date(d)).format("YYYY-MM-DD HH:mm:ss")
        this.setState({
            delivered_date_for_update: date
        })


    }
    render() {
        const { show, basicTitle, basicType, oRowData, pending, liabilityCnt, modules, rowData, defaultColDef, detailCellRendererParams, sideBar, frameworkComponents, statusBar, paginationPageSize, rowSelection, sliderSupportshow, supportDocTitle, shipment_slider, manual_upload_slider,
            gc_way_bill_No_sel, gcWayBillList, multiplePodDocs, loadshow, overly
        } = this.state
        let checkSelect = true;
        if (this.state.tabThree === "btn-current" || this.state.tabTow === "btn-current") {
            checkSelect = false
        }
        if (this.state.tabTow === "btn-current") {
            var hh = true;
            var shh = false;
        }
        else {
            var hh = false;
            var shh = true;
        }
        const userEmail = (localStorage.getItem("email") || "").toLowerCase();
        const isadminlogin = ["gowsigan@ashokleyland.com"]
        const isEnmovillogin = /enmovil\.(in|ai)$/.test(userEmail) || isadminlogin.includes(userEmail);
        var hideupdate = hh ? true : localStorage.getItem("is_tracking_view") == "true" ? false : true;
        // console.log(localStorage.getItem("is_tracking_view"), hideupdate, "123")
        let columnDefs = [
            // {
            // 	headerName: "",
            // 	field: "_id",
            // 	width: 70,
            // 	pinned: 'left',
            //     hide:hideupdate,
            // 	cellRenderer: 'courierActions',
            // 	filter: false,

            // },
            {
                headerName: Constants.TRIP_PLANT_CODE,
                field: "consigner_code",
                width: 120,
                checkboxSelection: checkSelect,
                headerCheckboxSelection: checkSelect
            },
            { 
                headerName: "",
                field: "",
                width: 50,
                minWidth: 50,
                filter: false,
                cellRendererSelector: () => ({ component: "ViewLogsButton" }),
            },
            {
                headerName: "Workflow Status",
                field: "workflow_status",
                width: 180,
                cellStyle: { fontWeight: 'bold' },
                valueGetter: (params) => getWorkflowDisplayStatus(params.data, { ocrEligibleGateStates: this.state.epodOcrEligibleStates, ocrReview: this.ocrReviewOpts() }).text,
                // cellRenderer: (params) => {
                //     var resolved = getWorkflowDisplayStatus(params.data, { ocrEligibleGateStates: this.state.epodOcrEligibleStates, ocrReview: this.ocrReviewOpts() });
                //     var span = document.createElement('span');
                //     span.className = STATUS_BADGE_CLASS[resolved.style] || STATUS_BADGE_CLASS.secondary;
                //     span.innerText = '● ' + resolved.text;
                //     var tooltip = getWorkflowStatusTooltip(resolved);
                //     if (tooltip) span.title = tooltip;
                //     return span;
                // },
            },
            {
                headerName: Constants.TRIP_PLANT_NAME,
                field: "consigner_name",
                width: 100,
            },
            {
                headerName: Constants.TRIP_CONSIGN_NO,
                field: "consignment_code",
                width: 80,
            },
            {
                headerName: Constants.TRIP_TRUCK_NO,
                field: "truck_no",
                width: 120,
                // checkboxSelection: checkSelect
            },
            {
                headerName: Constants.GC_WAY_BILL_NO,
                field: "gc_waybill_no",
                width: 120,
                // checkboxSelection: checkSelect
            },
            {
                headerName: Constants.GC_DATE,
                field: "gc_date",
                width: 120,
                valueGetter: function (params) {
                    try {
                        if (params.data.gc_date != undefined && params.data.gc_date != "") {
                            return getHyphenDDMMMYYYYHHMM(params.data.gc_date);
                        }
                    }
                    catch (e) { }
                }
                // checkboxSelection: checkSelect
            },

            {
                headerName: Constants.STATUS,
                field: "consignment_status",
                width: 120,
                filter: "agSetColumnFilter",
                cellStyle: function (params) {
                    if (params.value == 'Delivered') {
                        //mark police cells as red
                        return { color: 'green' };
                    } else {
                        return null;
                    }
                },
                valueGetter: function (params) {
                    if (params.data.consignment_status == "Cancelled") {
                        return "Cancelled As Per Ashok Leyland"
                    }
                    else {
                        return params.data.consignment_status
                    }
                }
            },
            {
                headerName: "OCR Verification",
                field: "is_verified_epod",
                // hide: this.state.tabTow !== "btn-current",
                hide: this.state.tabTow !== "btn-current" || !isEnmovillogin,
                width: 150,
                valueGetter: (params) => params.data.is_verified_epod === true ? "Verified" : "Not Verified"
            },
            {
                headerName: "OCR Delivery Date",
                field: "stamp_date",
                hide: this.state.tabTow !== "btn-current" || !isEnmovillogin,
                width: 150,
                valueGetter: function (params) {
                    try {
                        if (params.data.stamp_date != undefined && params.data.stamp_date != "") {
                            return getHyphenDDMMMYYYY(params.data.stamp_date);
                        }
                    }
                    catch (e) { }
                }
            },
            {
                headerName: "OCR GC/Way",
                field: "ocr_gc_waybill_no",
                hide: this.state.tabTow !== "btn-current" || !isEnmovillogin,
                width: 150,
                // valueGetter: (params) => params.data.is_verified_epod === true ? "Verified" : "Not Verified"
            },
            {
                headerName: "OCR Delivery Date Matched",
                field: "is_ocr_stamp_date_matched",
                hide: this.state.tabTow !== "btn-current" || !isEnmovillogin,
                width: 150,
                valueGetter: (params) => params.data.is_ocr_stamp_date_matched === true ? "Matched" : "Not Matched"
            },
            {
                headerName: "Stamp Identified",
                field: "is_stamp_identified",
                hide: this.state.tabTow !== "btn-current" || !isEnmovillogin,
                width: 150,
                valueGetter: (params) => params.data.is_stamp_identified === true ? "Yes" : "No"
            },
            {
                // Raw value, shown as-is (success/failed) - not remapped to a friendly label like
                // epod_gate_status below, since the ask here is just "tell me the latest OCR
                // outcome". Not tab-gated for the same reason as the two columns below.
                headerName: "OCR Status",
                field: "epod_ocr_status",
                hide: !isEnmovillogin,
                width: 130,
                // Arrow function (needs this.state.epodOcrEligibleStates) - display-only derived
                // value, no field is ever written for "In Progress". A stored epod_ocr_status is
                // only shown as-is if it actually belongs to the CURRENT upload_seq - the same
                // staleness check epodOcrService.js uses internally - otherwise it's a leftover
                // result from a prior upload and must not be shown as if it were current.
                valueGetter: (params) => {
                    var raw = params.data.epod_ocr_status;
                    var gate = params.data.epod_gate;
                    var ocr = params.data.epod_ocr;
                    var currentSeq = gate && gate.upload_seq;
                    var isCurrentResult = raw && ocr && Number(ocr.upload_seq) === Number(currentSeq);
                    // Verified by the AL Team instead of OCR (epod_ocr_review) - not an OCR pass.
                    var ocrReview = getOcrReviewState(params.data, this.ocrReviewOpts());
                    if (ocrReview && ocrReview.decided === 'approved') return "Approved manually";
                    if (isCurrentResult) return raw;
                    var eligibleStates = this.state.epodOcrEligibleStates || [];
                    if (gate && eligibleStates.indexOf(params.data.epod_gate_status) !== -1) {
                        return "In Progress";
                    }
                    return "";
                }
            },
            {
                // epod_ocr.upload_seq - which upload attempt (1st, 2nd, ...) the OCR result belongs
                // to, straight from the document, so the admin can tell how many times this LR's
                // e-POD has been (re)uploaded without opening the raw record.
                headerName: "OCR Upload Seq",
                field: "epod_ocr_upload_seq",
                hide: !isEnmovillogin,
                width: 130,
                valueGetter: function (params) {
                    var ocr = params.data.epod_ocr || {};
                    return (ocr.upload_seq === undefined || ocr.upload_seq === null) ? "" : ocr.upload_seq;
                }
            },
            {
                // Not tab-gated like the OCR columns above - an OCR failure is exactly what keeps
                // a row out of the Closed tab (it never reaches process_status:0), so this needs to
                // be visible wherever that row actually shows up (Pending/Total).
                headerName: "OCR Failure Reason",
                field: "epod_ocr_failure_reason",
                hide: !isEnmovillogin,
                width: 240,
                // Same staleness check as OCR Status above - a "failed" result left over from a
                // superseded upload_seq must not display next to a re-upload that's now correctly
                // showing "In Progress".
                valueGetter: function (params) {
                    var ocr = params.data.epod_ocr || {};
                    var gate = params.data.epod_gate;
                    var isCurrentResult = gate && Number(ocr.upload_seq) === Number(gate.upload_seq);
                    if (params.data.epod_ocr_status !== "failed" || !isCurrentResult) return "";
                    return ocr.failure_reason || "";
                }
            },
            {
                // Phase 2 status for the LSP's own e-POD (upload / late-upload approval / OCR),
                // INCLUDING why OCR failed - the Workflow Status column below reports the dealer
                // track for an LR on the independent dealer flow, so it can no longer carry this.
                // Populated only for those LRs (blank for every other row) and the column stays
                // hidden until at least one is loaded, so screens are unchanged while that flow is
                // switched off. Not shown to the dealer (CUSTOMER).
                headerName: "POD Verification",
                field: "epod_pod_verification",
                hide: localStorage.getItem("user_type") === "CUSTOMER" || !this.hasIndependentRows(),
                width: 300,
                valueGetter: (params) => {
                    var s = getPodVerificationStatus(params.data, { ocrEligibleGateStates: this.state.epodOcrEligibleStates, ocrReview: this.ocrReviewOpts() });
                    return s ? s.text : "";
                },
                cellStyle: (params) => (typeof params.value === "string" && params.value.indexOf("OCR Failed") === 0) ? { color: "#c0392b" } : null,
            },
            // --- e-POD late-upload gate (epod_late_upload config) -------------------------------
            // Both columns are hidden entirely while the feature is disabled, so this screen is
            // unchanged for existing users until the config is switched on. Records that predate
            // the feature have no epod_gate_status and render blank, never "late".
            {
                // Internal enum names (cleared / late_pending_approval / late_approved /
                // late_rejected) are never shown to the user - only these friendly labels.
                headerName: "e-POD Upload Status",
                field: "epod_gate_status",
                hide: !this.state.epodGateEnabled,
                width: 170,
                valueGetter: function (params) {
                    var s = params.data.epod_gate_status;
                    if (s === undefined || s === null || s === "") return "";
                    if (s === "cleared") return "Cleared";
                    if (s === "late_pending_approval") return "Pending Approval";
                    if (s === "late_approved") return "Approved";
                    if (s === "late_rejected") return "Rejected";
                    return s;
                }
            },
            {
                headerName: "Late Upload Detail",
                field: "epod_gate",
                hide: !this.state.epodGateEnabled,
                width: 220,
                valueGetter: function (params) {
                    var g = params.data.epod_gate;
                    if (!g) return "";
                    var bits = [];
                    // Stored in the window's own unit (epod_sla) - records saved before it existed have no
                    // window_unit and were always in days.
                    var u = g.window_unit === 'hours' ? 'h' : g.window_unit === 'months' ? 'mo' : 'd';
                    if (g.elapsed_days !== undefined && g.elapsed_days !== null) bits.push(g.elapsed_days + u + " elapsed");
                    if (g.allowed_days !== undefined && g.allowed_days !== null) bits.push("limit " + (g.window_text || (g.allowed_days + u)));
                    if (g.reviewed_by_email) bits.push("by " + g.reviewed_by_email);
                    // Why the upload was held for AL approval (OCR re-upload limit / window missed /
                    // late) - only present once epod_late_upload.ocr_retry is enabled.
                    if (g.approval_reason) bits.push(g.approval_reason);
                    return bits.join(" | ");
                }
            },
            {
                // The AL Team's latest decision on this e-POD, with its remarks: the decision on an
                // e-POD that failed OCR (epod_ocr_review) when there is one for the current upload,
                // otherwise the decision on a held (late / re-upload) upload. Both are scoped to the
                // current upload, so remarks from a superseded upload never show. Not shown to the
                // dealer. (field keeps its old id so saved grid layouts still place the column.)
                headerName: "AL POD Remarks",
                field: "epod_gate_rejection_remarks",
                hide: !this.state.epodGateEnabled || localStorage.getItem("user_type") === "CUSTOMER",
                width: 280,
                valueGetter: (params) => {
                    var label = (status, remarks) => (status === 'approved' ? 'Approved' : 'Rejected') + (remarks ? ': ' + remarks : '');
                    var ocrReview = getOcrReviewState(params.data, this.ocrReviewOpts());
                    if (ocrReview && ocrReview.decided) return label(ocrReview.decided, ocrReview.review.remarks);
                    var g = params.data.epod_gate;
                    var s = params.data.epod_gate_status;
                    if (g && (s === "late_approved" || s === "late_rejected") && (g.review_remarks || s === "late_rejected")) {
                        return label(s === "late_approved" ? 'approved' : 'rejected', g.review_remarks);
                    }
                    return "";
                }
            },
            // --- Workflow Status - single, role-agnostic, human-readable summary of where this
            // LR/consignment currently stands (POD Upload -> OCR -> Late Upload Gate -> Dealer
            // Confirmation -> AL Review -> Document Generation -> Signed Upload). Visible to every
            // user_type - unlike the role-scoped "Dealer Condition"/"AL Review" columns below, this
            // answers "where is this LR in the workflow", not "what button does this particular
            // user have" (those two columns, and their own action columns, are completely unchanged
            // by this addition).
            // Reads fields already present directly on this row (dealer_confirmation_status,
            // dealer_confirmation_rejection_pending, epod_gate_status, epod_gate/epod_ocr
            // (upload_seq-correlated), epod_document_status/type, epod_signed_document_status - the
            // same fields the columns below/above already read, some via the qrow maps, here read
            // straight off params.data) - see workflowStatus.js for the full precedence and the
            // single centralized label mapping this reuses everywhere. ocrEligibleGateStates is the
            // same config-driven list the "OCR Status" column above already uses (never hardcoded).
            // --- EPOD Phase 4 - AL Review (Action 16), Enmovil/AL admin logins only -------------
            // Brought inline here so approving/rejecting a dealer's NDV doesn't require navigating
            // to the separate /alReview screen. alReviewQueueMap is the ONLY eligibility signal
            // this column ever looks at (sourced 1:1 from /billing/alReviewQueue) - never
            // recomputed from dealer_confirmation_status client-side beyond what that response says.
            {
                headerName: "AL Review",
                field: "al_review_action",
                hide: !this.isAlReviewVisible(),
                width: 300,
                // Text-only - the Approve/Reject entry point lives in the separate "AL Review
                // Action" column right after this one, so this cell never mixes text and a button.
                valueGetter: (params) => {
                    var qrow = this.state.alReviewQueueMap[String(params.data._id)];
                    if (!qrow) return "";
                    var cond = qrow.dealer_confirmation_condition || "";
                    var ndvSuffix = (qrow.ndv_amount !== undefined && qrow.ndv_amount !== null) ? ", NDV: Rs. " + qrow.ndv_amount : "";
                    var qtySuffix = (cond === "shortage" && qrow.shortage_quantity !== undefined && qrow.shortage_quantity !== null) ? ", qty: " + qrow.shortage_quantity : "";
                    if (qrow.dealer_confirmation_status === "al_approved") return "AL Approved (" + cond + ndvSuffix + ")";
                    if (qrow.dealer_confirmation_status === "al_rejected") return "AL Rejected (" + cond + ")";
                    if (qrow.dealer_confirmation_status === "pending_al_review") return "Pending AL Review (" + cond + qtySuffix + ndvSuffix + ")";
                    return qrow.dealer_confirmation_status || "";
                }
            },

            {
                headerName: "System Delivered Date",
                field: "delivery_datetime",
                width: 160,
                valueGetter: function (params) {
                    try {
                        if (params.data.delivery_datetime != undefined && params.data.delivery_datetime != "") {
                            return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime);
                        }
                    }
                    catch (e) { }
                }
                // checkboxSelection: checkSelect
            },

            {
                headerName: "Transporter Mark Delivered Date",
                field: "delivered_date",
                width: 160,
                hide: shh,
                valueGetter: function (params) {
                    try {
                        if (params.data.delivered_date != undefined && params.data.delivered_date != "") {
                            return getHyphenDDMMMYYYY(params.data.delivered_date);
                        }
                    }
                    catch (e) { }
                }
                // checkboxSelection: checkSelect
            },
            // {
            //     headerName: Constants.SHIPMENT_COMPLETION_TIME,
            //     field: "shipment_completion_date",
            //     width: 160,
            //     valueGetter: function (params) {
            //         try {
            //             if (params.data.shipment_completion_date != undefined && params.data.shipment_completion_date != "") {
            //                 return getHyphenDDMMMYYYYHHMM(params.data.shipment_completion_date);
            //             }
            //         }
            //         catch (e) { }
            //     }
            //     // checkboxSelection: checkSelect
            // },
            // {
            //     headerName: Constants.SHIPMENT_START_TIME,
            //     field: "shipment_start_date",
            //     width: 120,
            //     valueGetter: function (params) {
            //         try {
            //             if (params.data.shipment_start_date != undefined && params.data.shipment_start_date != "") {
            //                 return getHyphenDDMMMYYYYHHMM(params.data.shipment_start_date);
            //             }
            //         }
            //         catch (e) { }
            //     }
            //     // checkboxSelection: checkSelect
            // },
            {
                headerName: Constants.SHIPMENT_TYPE,
                field: "shipping_type",
                width: 120,
                valueGetter: function (params) {
                    try {
                        var sdata = params.data.shipping_type;
                        var sdataoVal = sdata;
                        if (sdata === "05" || sdata === 5) {
                            var sdataoVal = "surface";
                        }
                        if (sdata === "07" || sdata === 7) {
                            var sdataoVal = "air";
                        }
                        if (sdata === "22" || sdata === 22) {
                            var sdataoVal = "train";
                        }
                        if (sdata === "48" || sdata === 48 || sdata === "47" || sdata === 47) {
                            var sdataoVal = "Part truck Load";
                        }
                        if (["01", "02", "03", "04", "10", "11", "12", "14", "15", "17", "18", "21", "24", "25", "29", "30", "31", "32", "45", "46"].includes(sdata)) {
                            var sdataoVal = "Full Truck Load";
                        }
                        if (sdata === "86" || sdata === 86) {
                            var sdataoVal = "Adjustment Load";
                        }
                        if (sdata === "00" || sdata === "06") {
                            var sdataoVal = "Over Dimensional Cargo";
                        }
                        if (sdata === "74" || sdata === 74) {
                            var sdataoVal = "Multi Point Delivery";
                        }
                        if (sdata === "HD") {
                            var sdataoVal = "Hand Delivery";
                        }
                        return sdataoVal;
                    } catch (error) {

                    }
                }
                // checkboxSelection: checkSelect
            },
            // {
            //     headerName: Constants.CREDIT_SALES,
            //     field: "credit_sales",
            //     width: 120,
            //     // checkboxSelection: checkSelect
            // },
            {
                headerName: Constants.TRIP_TRANSPORTER_CODE,
                field: "transporter_code",
                width: 180,
            },
            {
                headerName: Constants.TRIP_TRANSPORTER_NAME,
                field: "service_provider",
                width: 180,
            },

            {
                headerName: Constants.TRIP_CUSTOMER_CODE,
                field: "consignee_code",
                width: 100,
            },
            {
                headerName: Constants.TRIP_CUSTOMER_NAME,
                field: "consignee_name",
                width: 180,
            },
            {
                headerName: Constants.TRIP_CUSTOMER_CITY,
                field: "consignee_city",
                width: 160,
            },
            {
                headerName: Constants.TRIP_CUSTOMER_STATE,
                field: "consignee_state",
                width: 150,
            },
            {
                headerName: Constants.TRIP_ZONE,
                field: "consignee_region",
                width: 140,
            },
            {
                headerName: Constants.TRIP_PIN_CODE,
                field: "consignee_pincode",
                width: 180,
            },
            // {
            //     headerName: Constants.TRIP_ACTUAL_DELIVERY_DATE,
            //     field: "actual_delivery_date",
            //     width: 180,
            //     valueGetter: function (params) {
            //         try {
            //             if (params.data.actual_delivery_date != undefined && params.data.actual_delivery_date != "") {
            //                 return getHyphenDDMMMYYYYHHMM(params.data.actual_delivery_date);
            //             }

            //         }
            //         catch (e) { }
            //     }
            // },
            // {
            //     headerName: Constants.TRIP_STATUS,
            //     field: "trip_status_txt",
            //     width: 160,
            // },
            // {
            //     headerName: Constants.TRIP_INV_DATE,
            //     field: "invoice_date",
            //     width: 140,
            //     valueGetter: function (params) {
            //         try {
            //             if (params.data.invoice_date != undefined && params.data.invoice_date != "") {
            //                 return getHyphenDDMMMYYYYHHMM(params.data.invoice_date);
            //             }

            //         }
            //         catch (e) { }
            //     }
            // },
            // {
            //     headerName: Constants.TRIP_REACHED_DEST_DATE,
            //     field: "recent_dealer_reported",
            //     width: 140,
            //     valueGetter: function (params) {
            //         try {
            //             if (params.data.recent_dealer_reported != undefined && params.data.recent_dealer_reported != "") {
            //                 return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
            //             }
            //         }
            //         catch (e) { }
            //     }
            // },
            // {
            //     headerName: Constants.TRIP_TOTAL_DISTANCE_KM,
            //     field: "total_distance_travelled_km",
            //     width: 140,
            //     valueGetter: function (params) {
            //         try {
            //             if (params.data.total_distance_travelled_km != undefined && params.data.total_distance_travelled_km != "") {
            //                 return parseInt(parseInt(params.data.total_distance_travelled_km) / 1000);
            //             }
            //         }
            //         catch (e) { }
            //     }
            // },
            // {
            //     headerName: Constants.TRIP_TOTAL_TRIP_DISTANCE_KM,
            //     field: "total_travelled_trip_dist_km",
            //     width: 100,
            // },
            // {
            //     headerName: Constants.TRIP_DURATION_DAYS,
            //     field: "trip_duration_days",
            //     width: 100,
            // },
            // {
            //     headerName: Constants.TRIP_FREIGHT_COST,
            //     field: "freight_rate",
            //     width: 100,
            // },
            // {
            //     headerName: Constants.TRIP_TOTAL_COST,
            //     field: "total_cost",
            //     width: 100
            // },



            {
                headerName: "Reverted By",
                field: "epod_last_revert.reverted_by_email",
                width: 160,
                // Feature-flag gated (epod_pod_revert), same pattern as the OCR columns' epodGateEnabled
                // gate - stays hidden until the backend confirms the redesigned revert flow is on.
                hide: !this.state.epodPodRevertEnabled,
                valueGetter: function (params) {
                    var r = params.data && params.data.epod_last_revert;
                    return r ? (r.reverted_by_name || r.reverted_by_email || '-') : '';
                },
            },
            {
                headerName: "Reverted At",
                field: "epod_last_revert.reverted_at",
                width: 150,
                hide: !this.state.epodPodRevertEnabled,
                valueGetter: function (params) {
                    var r = params.data && params.data.epod_last_revert;
                    return r && r.reverted_at ? moment(r.reverted_at).format('DD-MM-YYYY HH:mm') : '';
                },
            },
            {
                headerName: "Revert Reason",
                field: "epod_last_revert.revert_reason",
                width: 200,
                hide: !this.state.epodPodRevertEnabled,
                valueGetter: function (params) {
                    var r = params.data && params.data.epod_last_revert;
                    return r ? (r.revert_reason || '-') : '';
                },
            },

            // --- Damage Files - visible for ALL user types (never hidden by user_type). Backend
            // authorization (dealerDamageFilesSummary/dealerDamageFiles) remains the actual
            // gate - this column only ever shows a count/button for a row the backend already
            // agreed the caller may see; it never computes eligibility itself. -------------------
            {
                headerName: "Damage Files",
                field: "damage_files_action",
                width: 150,
                valueGetter: (params) => {
                    var n = (this.state.damageFilesCountMap || {})[String(params.data._id)] || 0;
                    return n > 0 ? "View Files (" + n + ")" : "-";
                },
                cellRendererSelector: () => ({ component: "DamageFilesAction" }),
            },
            // --- Action columns, grouped together at the right end of the scrollable area
            // (relocated here from earlier in columnDefs; only their array position and `pinned`
            // changed - renderer/handler/eligibility logic below is byte-for-byte unchanged). Only
            // Upload POD and View POD stay pinned right; everything else here scrolls normally so
            // the pinned strip doesn't crowd out the data columns above. ------------------------
            {
                // Unified AL Action - every approval the AL team owes on this row in ONE column
                // (held e-POD upload, dealer NDV review, future steps; see alActions.js), each button
                // labelled by what it decides with a hover tooltip saying what it does. Visible only
                // to a login that can decide at least one of them: the backend says whether it may
                // decide a held upload (epodGateCanReview - never the LSP or dealer), and
                // isAlReviewVisible() is the unchanged rule for the NDV review. Buttons call the same
                // handlers the two original columns below call.
                headerName: "AL Action",
                field: "al_unified_action",
                hide: !UNIFIED_AL_ACTIONS || !((this.state.epodGateEnabled && this.state.epodGateCanReview) || this.isAlReviewVisible()),
                width: 270,
                pinned: "right",
                filter: false,
                valueGetter: () => "",
                cellRendererSelector: (params) => {
                    if (!UNIFIED_AL_ACTIONS) return undefined;
                    return getAlActions(params.data, this).length > 0 ? { component: "AlUnifiedActions" } : undefined;
                }
            },
            {
                // Original late-upload approval column - replaced by the unified column above while
                // UNIFIED_AL_ACTIONS is true. Never shown to the LSP / dealer either way.
                headerName: "AL Action",
                field: "epod_gate_action",
                hide: UNIFIED_AL_ACTIONS || !this.state.epodGateEnabled || !this.state.epodGateCanReview,
                width: 170,
                // pinned: "right",
                cellRendererSelector: (params) => {
                    // Only a record actually awaiting approval gets an action, and only for the
                    // actions the backend config currently enables.
                    if (params.data.epod_gate_status !== "late_pending_approval") return null;
                    var enabled = Object.keys(this.state.epodGateActions || {})
                        .filter((k) => this.state.epodGateActions[k] === true);
                    if (enabled.length === 0) return null;
                    return { component: "EpodGateActions" };
                }
            },
            // --- EPOD Phase 3 - Dealer Condition (CUSTOMER logins only) -------------------------
            // Hidden entirely for every other user_type, so this screen is pixel-for-pixel
            // unchanged for AL/Admin/Transporter/LSP. Eligibility (whether buttons show at all) is
            // decided purely by whether this row's _id is present in dealerConditionQueueMap - the
            // existing /billing/dealerConfirmationQueue response - never recomputed here from
            // epod_ocr_status or anything else.
            {
                headerName: "Dealer Condition",
                field: "dealer_condition_action",
                hide: localStorage.getItem("user_type") !== "CUSTOMER",
                width: 120,
                pinned: "right",
                valueGetter: (params) => {
                    var qrow = this.state.dealerConditionQueueMap[String(params.data._id)];
                    if (!qrow) return "";
                    if (qrow.dealer_confirmation_status === "closed_clean") return "Clean - Closed";
                    if (qrow.dealer_confirmation_status === "closed_damage") return "Damage - Closed";
                    if (qrow.dealer_confirmation_status === "pending_al_review") return "Pending AL Review (" + (qrow.dealer_confirmation_condition || "") + ")";
                    if (qrow.dealer_confirmation_status) return qrow.dealer_confirmation_status;
                    if (isAwaitingDealer(qrow)) return "Awaiting Your Confirmation";
                    return "";
                },
                cellRendererSelector: (params) => {
                    if (localStorage.getItem("user_type") !== "CUSTOMER") return null;
                    var qrow = this.state.dealerConditionQueueMap[String(params.data._id)];
                    if (!qrow) return null;
                    return { component: "DealerConditionActions" };
                }
            },
            {
                headerName: "AL Review Action",
                field: "al_review_button_action",
                hide: UNIFIED_AL_ACTIONS || !this.isAlReviewVisible(),
                width: 140,
                pinned: "right",
                filter: false,
                // Button-only (alReviewCellAction.js) - renders nothing at all unless this row is
                // currently pending_al_review; approved/rejected rows show blank here since their
                // outcome is already visible in the "AL Review" text column.
                valueGetter: () => "",
                cellRendererSelector: (params) => {
                    if (!this.isAlReviewVisible()) return undefined;
                    var qrow = this.state.alReviewQueueMap[String(params.data._id)];
                    if (!qrow || qrow.dealer_confirmation_status !== "pending_al_review") return undefined;
                    return { component: "AlReviewCellAction" };
                }
            },
            {
                headerName: "Update",
                field: "view",
                width: 150,
                filter: false,
                hide: hideupdate,
                cellRenderer: function (params) {
                    if (params.data.consignment_status == 'Delivered') {
                        return `<button class="btn btn-info" disabled>Update Tracking</button>`
                    } else {
                        return `<button class="btn btn-info">Update Tracking</button>`
                    }
                }
            },
            {
                headerName: "Revert POD",
                field: "",
                width: 120,
                // Part B - CUSTOMER never sees Revert POD, regardless of the existing tab-based
                // shh rule below (unchanged for every other user_type).
                hide: shh || localStorage.getItem("user_type") === "CUSTOMER",
                filter: false,
                // Arrow function (not a plain function like the other action columns) - needs
                // `this.state` for the epod_revert_lock config, unlike Upload/View POD's selectors
                // which only ever read params.data/localStorage.
                cellRendererSelector: (params) => {
                    if (this.state.epodRevertLockEnabled) {
                        var appliesToThisUser = this.state.epodRevertLockAppliesTo === 'admin_only' ? isEnmovillogin : true;
                        // Once locked, this stays hidden regardless of consignment_status - a
                        // terminal e-POD has nothing left to revert to, delivered or not.
                        // An LR on the independent dealer flow is exempt: its dealer/AL/document state
                        // no longer depends on the e-POD, and the backend revert only resets Phase 2
                        // for it (epodPodRevertService.revertPod), so there is nothing to protect.
                        if (appliesToThisUser && !isIndependentRow(params.data) && this.isEpodWorkflowTerminal(params.data)) return undefined;
                    }
                    if (params.data.consignment_status === "Delivered" || params.data.consignment_status === "DELIVERED") {
                        return {
                            component: "RevertPOD"
                        }
                    }
                    else {
                        return undefined
                    }

                },
            },
            {
                headerName: "COF / Credit Note",
                field: "",
                width: 150,
                pinned: "right",
                // NOT user_type-gated at the column level (unlike Upload POD/Revert POD) - Upload
                // and View have different audiences per isDocumentAccessAllowed() (alReviewService.js):
                // Upload is LSP-only (isUploadAuthorized), unaffected by cof_view. View (once
                // uploaded) is config-driven per role via al_review's own cof_view block
                // (state.alReviewOptions.cof_view, fetched by the EXISTING loadAlReviewOptions() -
                // no new endpoint) - Dealer is denied by DEFAULT (allow_dealer: false, today's
                // production behavior) but can be turned on later purely via a DB config change,
                // with zero code change here. The backend re-validates independently on every click
                // regardless of what this column shows - this is UI discoverability only. Row-level
                // ownership for Transporter (a Transporter only ever HAS this row in their grid to
                // begin with) is already enforced by the existing /consignments/couriers listing
                // scoping, same precedent as View POD/View Damage Files needing no extra per-row
                // check here.
                //
                // Covers BOTH document types generateDocument() (Action 18) can produce - 'cof' AND
                // 'credit_note' - previously this column only ever recognized 'cof' and silently
                // hid the action for every credit_note-classified row (NDV <= ndv_credit_note_max,
                // the more common classification), even though the backend
                // (isDocumentAccessAllowed/isUploadAuthorized/resolveGeneratedDocument/
                // uploadSignedDocument) has always treated both types identically end to end.
                filter: false,
                // Arrow function (not a plain function like most other action columns) - needs
                // this.state for cof_view, same reason the Revert POD column's own selector above
                // is an arrow function for epod_revert_lock.
                cellRendererSelector: (params) => {
                    // epod_document_type/epod_document_id are only ever set by generateDocument()
                    // AFTER the required AL/Admin approval (dealer_confirmation_status === 'al_approved')
                    // - that existing approval gate is what makes this column appear at all; nothing
                    // new is introduced here to represent "approved".
                    var docType = params.data.epod_document_type;
                    if ((docType !== 'cof' && docType !== 'credit_note') || !params.data.epod_document_id) return undefined;
                    var userType = localStorage.getItem("user_type");
                    var uploaded = params.data.epod_signed_document_status === 'signed_uploaded';
                    if (uploaded) {
                        // cof_view is a COF-ONLY config concept - mirrors isDocumentAccessAllowed()'s
                        // own `documentType === 'cof' ? cofViewCfg : null` split exactly. Credit
                        // Note's view rule is the existing, unconditional backend rule instead
                        // (Admin/Transporter always allowed, Dealer NEVER - a hard rule that is never
                        // config-gated) - it must not be routed through cof_view.allow_dealer/
                        // allow_transporter, which would incorrectly couple it to a COF-only switch.
                        if (docType === 'cof') {
                            var cofViewCfg = this.state.alReviewOptions.cof_view || {};
                            if (!cofViewCfg.enabled) return undefined;
                            // "View COF Note" - Admin/AL Team (isEnmovillogin, the existing admin
                            // heuristic this same file already uses for the Revert-lock admin_only
                            // branch), Transporter/LSP, and Dealer ONLY if config explicitly allows it -
                            // mirrors isDocumentAccessAllowed()'s own per-role cof_view read exactly.
                            if (isEnmovillogin && cofViewCfg.allow_admin) return { component: "CofUpload" };
                            if (userType === "TRANSPORTER" && cofViewCfg.allow_transporter) return { component: "CofUpload" };
                            if (userType === "CUSTOMER" && cofViewCfg.allow_dealer) return { component: "CofUpload" };
                            return undefined;
                        }
                        if (isEnmovillogin) return { component: "CofUpload" };
                        if (userType === "TRANSPORTER") return { component: "CofUpload" };
                        return undefined; // CUSTOMER (Dealer) never sees a Credit Note - unconditional, matches isDocumentAccessAllowed()
                    }
                    // Not yet uploaded - only the Transporter/LSP gets the Upload action (backend's
                    // own isUploadAuthorized rule, unaffected by cof_view - mirrored here so Admin/
                    // Dealer just see a blank cell instead of a button they'd be rejected for).
                    // Identical for both document types - isUploadAuthorized() never distinguishes
                    // cof vs credit_note either.
                    if (userType !== "TRANSPORTER") return undefined;
                    return { component: "CofUpload" };
                },
            },
            {
                headerName: "Upload POD",
                field: "",
                width: 120,
                // Part B - CUSTOMER never sees Upload POD, regardless of the existing tab-based
                // checkSelect rule below (unchanged for every other user_type).
                hide: !checkSelect || localStorage.getItem("user_type") === "CUSTOMER",
                filter: false,
                pinned: "right",
                cellRendererSelector: function (params) {
                    // Once an e-POD has ever been uploaded for this row, epod_gate is set and
                    // stays set regardless of what an OCR check later does to is_submitted_pod/
                    // process_status - so it's a reliable "already uploaded" signal even across an
                    // OCR-failure revert, unlike is_submitted_pod alone.
                    var alreadyUploaded = params.data.is_submitted_pod === 1 || !!params.data.epod_gate;
                    // A failed OCR check means the uploaded file was rejected (bad stamp, wrong LR,
                    // etc.) - the corrective action is a fresh upload, so re-open Upload POD for
                    // exactly this case even though alreadyUploaded is true. Success (or no OCR
                    // result yet) keeps the upload closed once submitted.
                    var ocrFailed = params.data.epod_ocr_status === "failed";
                    if ((params.data.consignment_status === "Delivered" || params.data.consignment_status === "DELIVERED") && (!alreadyUploaded || ocrFailed)) {
                        return {
                            component: "UploadPOD"
                        }
                    }
                    else {
                        return " "
                    }

                },
            },
            {
                headerName: "View POD",
                field: "consignment_code",
                width: 100,
                // Every user_type (CUSTOMER included) used to only get this column on the Closed tab
                // (shh). Now shown on every tab so an already-uploaded row (including one an OCR
                // failure reverted back into Pending/Total) can still be inspected - but the column
                // only actually renders a button for a row that has really been uploaded; everywhere
                // else it stays blank, same as before. Same rule for dealers: no View POD on a
                // never-uploaded Pending row.
                hide: false,
                pinned: "right",
                // field is only "consignment_code" so this column gets its own colId (every other
                // action column here shares field:"" instead) - it is NEVER meant to display that
                // value, so valueGetter forces blank whenever cellRendererSelector opts out below.
                // Returning a bare string like " " from cellRendererSelector is NOT a valid "no
                // renderer" signal to ag-Grid - it falls back to rendering the raw field value
                // (which is why non-uploaded rows were showing the consignment_code number instead
                // of a blank cell). undefined is the correct signal.
                valueGetter: function () { return ""; },
                cellRendererSelector: function (params) {
                    var alreadyUploaded = params.data.is_submitted_pod === 1 || !!params.data.epod_gate;
                    if (!alreadyUploaded) return undefined;
                    return { component: "ViewPOD" }
                },
            },
        ]
        return (
            <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="col-xl-12 h3 mb-0 text-gray-800">E-Pod
                    </h1>
                </div>
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                {/* Reject E-POD - mandatory remarks confirmation modal.
                    Rejection is a two-step action: clicking "Reject" in the grid only opens this;
                    the API call happens exclusively from "Confirm Reject" below. "Cancel" (and the
                    backdrop / X) call onCancelEpodReject, which never touches the backend, so the
                    E-POD is left completely unchanged. */}
                {this.state.epodRejectModalShow ?
                    <div className="epod-reject-modal-backdrop"
                        style={{
                            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050,
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}
                        onClick={this.onCancelEpodReject}
                    >
                        <div className="modal-dialog" style={{ maxWidth: 480, width: '90%', margin: 0 }}
                            onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Reject E-POD</h5>
                                    <button type="button" className="close" aria-label="Close"
                                        onClick={this.onCancelEpodReject} disabled={this.state.epodRejectSubmitting}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {this.state.epodRejectRow ?
                                        <p className="mb-2">
                                            <b>LR Number:</b> {this.state.epodRejectRow.gc_waybill_no}
                                        </p>
                                        : null}
                                    <div className="form-group mb-1">
                                        <label>Rejection Remarks <span style={{ color: 'red' }}>*</span></label>
                                        <textarea
                                            className="form-control"
                                            rows="4"
                                            maxLength={this.state.epodGateMaxRemarksLength}
                                            value={this.state.epodRejectRemarks}
                                            onChange={this.onChangeEpodRejectRemarks}
                                            disabled={this.state.epodRejectSubmitting}
                                            placeholder="Explain why this e-POD is being rejected..."
                                            autoFocus
                                        />
                                        <small className="form-text text-muted">
                                            {this.state.epodRejectRemarks.length} / {this.state.epodGateMaxRemarksLength} characters
                                        </small>
                                    </div>
                                    {this.state.epodRejectError ?
                                        <div className="text-danger mb-1">{this.state.epodRejectError}</div>
                                        : null}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"
                                        onClick={this.onCancelEpodReject} disabled={this.state.epodRejectSubmitting}>
                                        Cancel
                                    </button>
                                    <button type="button" className="btn btn-danger"
                                        onClick={this.onConfirmEpodReject}
                                        disabled={this.state.epodRejectSubmitting || !this.state.epodRejectRemarks.trim()}>
                                        {this.state.epodRejectSubmitting ? 'Rejecting...' : 'Confirm Reject'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}
                {this.state.epodOcrReview ? (() => {
                    // AL decision on an e-POD that failed OCR - same modal pattern as Reject E-POD above.
                    var m = this.state.epodOcrReview
                    var isApprove = m.action === 'approve'
                    var remarksCfg = this.state.epodOcrReviewOptions.remarks || {}
                    var maxLen = remarksCfg.max_length || 500
                    var required = isApprove ? remarksCfg.required_on_approve !== false : remarksCfg.required_on_reject !== false
                    var ocrResult = (m.row.epod_ocr || {}).failure_reason
                    return (
                        <div className="epod-reject-modal-backdrop"
                            style={{
                                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                                backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050,
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}
                            onClick={this.onCancelOcrReview}
                        >
                            <div className="modal-dialog" style={{ maxWidth: 480, width: '90%', margin: 0 }}
                                onClick={(e) => e.stopPropagation()}>
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">{isApprove ? 'Approve E-POD Manually' : 'Reject E-POD'}</h5>
                                        <button type="button" className="close" aria-label="Close"
                                            onClick={this.onCancelOcrReview} disabled={m.submitting}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <p className="mb-1"><b>LR Number:</b> {m.row.gc_waybill_no}</p>
                                        {ocrResult ? <p className="mb-2"><b>OCR result:</b> {ocrResult}</p> : null}
                                        <p className="mb-2 text-muted" style={{ fontSize: 12 }}>
                                            {isApprove
                                                ? 'The e-POD will be treated as verified ("Approved manually") and will not go through OCR again.'
                                                : 'The transporter will be asked to upload a new e-POD.'}
                                        </p>
                                        <div className="form-group mb-1">
                                            <label>Remarks {required ? <span style={{ color: 'red' }}>*</span> : null}</label>
                                            <textarea
                                                className="form-control"
                                                rows="4"
                                                maxLength={maxLen}
                                                value={m.remarks}
                                                onChange={this.onChangeOcrReviewRemarks}
                                                disabled={m.submitting}
                                                placeholder={isApprove ? 'Why this e-POD is acceptable...' : 'What the transporter must correct...'}
                                                autoFocus
                                            />
                                            <small className="form-text text-muted">{m.remarks.length} / {maxLen} characters</small>
                                        </div>
                                        {m.error ? <div className="text-danger mb-1">{m.error}</div> : null}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary"
                                            onClick={this.onCancelOcrReview} disabled={m.submitting}>
                                            Cancel
                                        </button>
                                        <button type="button" className={isApprove ? "btn btn-success" : "btn btn-danger"}
                                            onClick={this.onConfirmOcrReview}
                                            disabled={m.submitting || (required && !m.remarks.trim())}>
                                            {m.submitting ? 'Submitting...' : (isApprove ? 'Confirm Approve' : 'Confirm Reject')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })() : null}

                {/* Revert POD - mandatory-reason confirmation modal, mirroring the Reject modal
                    above exactly. Clicking "Revert POD" in the grid only gets here - the actual
                    API call happens exclusively from "Confirm Revert" below. "Cancel" (and the
                    backdrop / X) call onCancelPodRevert, which never touches the backend, so the
                    e-POD is left completely unchanged. */}
                {this.state.epodPodRevertModalShow ?
                    <div className="epod-revert-modal-backdrop"
                        style={{
                            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050,
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}
                        onClick={this.onCancelPodRevert}
                    >
                        <div className="modal-dialog" style={{ maxWidth: 480, width: '90%', margin: 0 }}
                            onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Revert POD</h5>
                                    <button type="button" className="close" aria-label="Close"
                                        onClick={this.onCancelPodRevert} disabled={this.state.epodPodRevertSubmitting}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {this.state.epodPodRevertRow ?
                                        <p className="mb-2">
                                            <b>LR Number:</b> {this.state.epodPodRevertRow.gc_waybill_no}
                                        </p>
                                        : null}
                                    <p className="mb-2 text-muted">
                                        This will archive the current e-POD document/workflow state and reset
                                        this LR back to the upload stage. This cannot be undone.
                                    </p>
                                    <div className="form-group mb-1">
                                        <label>
                                            Revert Reason {this.state.epodPodRevertRequireReason ? <span style={{ color: 'red' }}>*</span> : null}
                                        </label>
                                        <textarea
                                            className="form-control"
                                            rows="4"
                                            maxLength={this.state.epodPodRevertMaxRemarksLength}
                                            value={this.state.epodPodRevertReason}
                                            onChange={this.onChangePodRevertReason}
                                            disabled={this.state.epodPodRevertSubmitting}
                                            placeholder="Explain why this e-POD is being reverted..."
                                            autoFocus
                                        />
                                        <small className="form-text text-muted">
                                            {this.state.epodPodRevertReason.length} / {this.state.epodPodRevertMaxRemarksLength} characters
                                        </small>
                                    </div>
                                    {this.state.epodPodRevertError ?
                                        <div className="text-danger mb-1">{this.state.epodPodRevertError}</div>
                                        : null}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"
                                        onClick={this.onCancelPodRevert} disabled={this.state.epodPodRevertSubmitting}>
                                        Cancel
                                    </button>
                                    <button type="button" className="btn btn-danger"
                                        onClick={this.onConfirmPodRevert}
                                        disabled={this.state.epodPodRevertSubmitting || (this.state.epodPodRevertRequireReason && !this.state.epodPodRevertReason.trim())}>
                                        {this.state.epodPodRevertSubmitting ? 'Reverting...' : 'Confirm Revert'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}

                {/* COF Note upload (Transporter/LSP only) - mirrors the Revert POD modal above
                    exactly. Clicking "Upload COF Note" in the grid only opens this; the actual
                    API call (the EXISTING /billing/alReviewDocumentSignedUpload, Action 19) happens
                    exclusively from "Upload" below. Cancel (or the backdrop/X) calls
                    onCancelCofUpload, which never touches the backend. */}
                {this.state.cofUploadModalShow ?
                    <div className="epod-cof-upload-modal-backdrop"
                        style={{
                            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050,
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}
                        onClick={this.onCancelCofUpload}
                    >
                        <div className="modal-dialog" style={{ maxWidth: 480, width: '90%', margin: 0 }}
                            onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Upload COF Note</h5>
                                    <button type="button" className="close" aria-label="Close"
                                        onClick={this.onCancelCofUpload} disabled={this.state.cofUploadSubmitting}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {this.state.cofUploadRow ?
                                        <p className="mb-2">
                                            <b>LR Number:</b> {this.state.cofUploadRow.gc_waybill_no}
                                        </p>
                                        : null}
                                    {/* <div className="alert alert-warning py-1 px-2 mb-2" style={{ fontSize: '12px' }}>
                                        Only this LR's own transporter may upload the COF Note. The backend
                                        re-validates this regardless of what this screen shows.
                                    </div> */}
                                    <div className="form-group mb-1">
                                        <label>COF Note File <span style={{ color: 'red' }}>*</span></label>
                                        <input type="file" className="form-control"
                                            onChange={this.onChangeCofFile} disabled={this.state.cofUploadSubmitting} />
                                    </div>
                                    {this.state.cofUploadError ?
                                        <div className="text-danger mb-1">{this.state.cofUploadError}</div>
                                        : null}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"
                                        onClick={this.onCancelCofUpload} disabled={this.state.cofUploadSubmitting}>
                                        Cancel
                                    </button>
                                    <button type="button" className="btn btn-warning"
                                        onClick={this.onConfirmCofUpload}
                                        disabled={this.state.cofUploadSubmitting || !this.state.cofUploadFile}>
                                        {this.state.cofUploadSubmitting ? 'Uploading...' : 'Upload'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}

                {/* EPOD FINAL - Dealer Condition (CUSTOMER only). "Review POD" slider - single entry
                    point for Clean/Shortage/Damage, replacing the old three separate modals. All
                    form state and the actual dealerConfirmClean/Shortage/Damage API calls live
                    inside ReviewPodSlider; this screen only supplies the row/options and reacts to
                    the outcome via onReviewPodSubmitted (same toast + queue-reload as before). */}
                {this.state.reviewPodRow ?
                    <ReviewPodSlider
                        show={true}
                        row={this.state.reviewPodRow}
                        options={this.state.dealerConditionOptions}
                        onClose={this.onCloseReviewPod}
                        onSubmitted={this.onReviewPodSubmitted}
                    />
                    : null}

                {/* ePOD Activity Log ("View Logs") - read-only timeline for the clicked row, keyed
                    by gc_waybill_no. Never changes any workflow/dealer/AL/document state - see
                    ViewLogsSlider's own header comment. */}
                {this.state.viewLogsRow ?
                    <ViewLogsSlider
                        row={this.state.viewLogsRow}
                        onClose={this.onCloseViewLogs}
                    />
                    : null}

                {/* EPOD Phase 4 - AL Review (Enmovil/AL admin only). View the dealer's submitted
                    NDV and Approve/Reject inline, without navigating to the separate /alReview
                    screen - reuses the exact same backend endpoints that screen uses. */}
                {this.state.alReviewModalRow ?
                    <AlReviewActionModal
                        row={this.state.alReviewModalRow}
                        options={this.state.alReviewOptions}
                        onClose={this.onCloseAlReview}
                        onSubmitted={this.onAlReviewSubmitted}
                    />
                    : null}

                {/* EPOD Phase 3 - Dealer Condition (CUSTOMER only). WEB-025 Reopen confirmation
                    modal, same pattern/API as dealerConfirmationScreen.js. */}
                {this.state.dcReopenModalShow ?
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        onClick={this.onCancelDcReopen}>
                        <div className="modal-dialog" style={{ maxWidth: 480, width: '90%', margin: 0 }} onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Reopen Confirmation</h5>
                                    <button type="button" className="close" onClick={this.onCancelDcReopen} disabled={this.state.dcReopenSubmitting}><span>&times;</span></button>
                                </div>
                                <div className="modal-body">
                                    {this.state.dcReopenRow ?
                                        <p className="mb-2">
                                            <b>LR Number:</b> {this.state.dcReopenRow.gc_waybill_no}<br />
                                            <b>Current Condition:</b> {this.state.dcReopenRow.dealer_confirmation_condition}
                                        </p>
                                        : null}
                                    <div className="alert alert-warning py-1 px-2 mb-2" style={{ fontSize: '12px' }}>
                                        This will reopen the confirmation so a corrected condition can be submitted. The
                                        original confirmation is preserved in history, not deleted.
                                    </div>
                                    <div className="form-group mb-1">
                                        <label>Reason for Reopening {this.state.dealerConditionOptions.condition_change.require_reopen_remarks ? <span style={{ color: 'red' }}>*</span> : '(optional)'}</label>
                                        <textarea className="form-control" rows="3" maxLength={this.state.dealerConditionOptions.max_remarks_length}
                                            value={this.state.dcReopenRemarks} onChange={this.onChangeDcReopenRemarks}
                                            disabled={this.state.dcReopenSubmitting} placeholder="Why is this being reopened?" autoFocus />
                                        <small className="form-text text-muted">{this.state.dcReopenRemarks.length} / {this.state.dealerConditionOptions.max_remarks_length} characters</small>
                                    </div>
                                    {this.state.dcReopenError ? <div className="text-danger mb-1">{this.state.dcReopenError}</div> : null}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.onCancelDcReopen} disabled={this.state.dcReopenSubmitting}>Cancel</button>
                                    <button type="button" className="btn btn-outline-secondary" onClick={this.onConfirmDcReopen}
                                        disabled={this.state.dcReopenSubmitting || (this.state.dealerConditionOptions.condition_change.require_reopen_remarks && !this.state.dcReopenRemarks.trim())}>
                                        {this.state.dcReopenSubmitting ? 'Reopening...' : 'Reopen'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}

                {/* Damage Files - visible for ALL user types (not just CUSTOMER). Files are
                    resolved only through /billing/dealerDamageFiles, which re-verifies ownership
                    server-side for whatever user_type is calling. List view shows one row per
                    file with a truncated, tooltip-backed filename (never a raw S3 key); clicking
                    Download follows the exact same pattern as the existing View POD (onClickViewPOD)
                    for every file type, images included - no in-app preview branch. */}
                {this.state.damageFilesModalShow ?
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        onClick={this.onCloseDamageFiles}>
                        <div className="modal-dialog" style={{ maxWidth: 560, width: '90%', margin: 0 }} onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Damage Files{this.state.damageFilesRow ? ' - LR ' + this.state.damageFilesRow.gc_waybill_no : ''}
                                    </h5>
                                    <button type="button" className="close" onClick={this.onCloseDamageFiles}><span>&times;</span></button>
                                </div>
                                <div className="modal-body">
                                    {this.state.damageFilesLoading ?
                                        <p className="mb-0 text-center">Loading files...</p>
                                        : null}

                                    {!this.state.damageFilesLoading && this.state.damageFilesItems.length > 0 ?
                                        <ul className="list-group">
                                            {this.state.damageFilesItems.map((item, idx) => (
                                                <li key={idx} className="list-group-item d-flex align-items-center justify-content-between" style={{ padding: '8px 12px' }}>
                                                    <span title={item.file_name} aria-label={item.file_name}
                                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 340, marginRight: 10 }}>
                                                        {idx + 1}. {item.file_name}
                                                        <span className="badge badge-secondary ml-2" style={{ fontSize: '10px' }}>{(item.ext || '').toUpperCase() || 'FILE'}</span>
                                                    </span>
                                                    <button type="button" className="btn btn-sm btn-outline-primary" style={{ flexShrink: 0 }}
                                                        disabled={!item.url} title={item.url ? undefined : (item.error || 'Unavailable')}
                                                        aria-label={'Download ' + item.file_name}
                                                        onClick={() => this.onClickDamageFileView(item)}>
                                                        Download
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                        : null}

                                    {this.state.damageFilesError ? <div className="text-danger mt-2 mb-0">{this.state.damageFilesError}</div> : null}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.onCloseDamageFiles}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}

                <div className="row mb-1">
                    <div className='card col-xl-12 col-md-12'>
                        <div className="card-body pb-0">
                            <div className="row">
                                <div className="col-2">
                                    <label>Start Date </label>
                                    <Datetime value={this.state.from_date}
                                        disableCloseOnClickOutside={false}
                                        closeOnSelect={true}
                                        inputProps={{ placeholder: 'From Date', name: 'startDate', autoComplete: 'off', readOnly: true }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat={false}
                                        name="fromDate"
                                        onChange={this.handlerStartDeliveryDateTime} />
                                </div>
                                <div className="col-2">
                                    <label>End Date </label>
                                    <Datetime
                                        value={this.state.to_date}
                                        disableCloseOnClickOutside={false}
                                        closeOnSelect={true}
                                        inputProps={{ placeholder: 'To Date', name: 'toDate', autoComplete: 'off', readOnly: true }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat={false}
                                        name="toDate"
                                        onChange={this.handlerEndDeliveryDateTime} />
                                </div>
                                {/* <div className="col-2">
                                    <label className="">Shipping Type</label>
                                    <Select
                                        value={this.state.shipType}
                                        name="shipType"
                                        options={[
                                            { value: "all", label: "All" },
                                            { value: "05", label: "Courier by surface" },//05 
                                            { value: "07", label: "Courier by air" }, //07
                                            { value: "22", label: "Courier by Train" },//22 
                                            { value: "PTL", label: "Part truck Load" }, //47,48 
                                            { value: "FTL", label: "Full truck Load" },//"01", "02", "03", "04", "10", "11", "12", "14", "15", "17", "18", "21", "24", "25","29", "30", "31", "32", "45", "46"
                                        ]}
                                        onChange={this.onChangeShipType.bind(this)}
                                    />
                                </div> */}
                                {localStorage.getItem("user_type") != "TRANSPORTER" ?
                                    <div className="col-2">
                                        <label>Transporter   </label>
                                        <Select
                                            className="border-radius-0"
                                            isMulti={false}
                                            closeMenuOnSelect={true}
                                            id="selectedTransporter"
                                            style={{ borderRadius: "0px" }}
                                            value={this.state.flTransporter}
                                            onChange={this.newFilter.bind(this, "flTransporter")}
                                            options={this.state.filterTransporters}
                                        />
                                    </div>
                                    : ""}
                                <div className="form-group col-xl-3 col-lg-3"   >
                                    <button className="btn btn-success mt-30p cc-btn cc-btn-form" type="submit" onClick={this.submitTransporterType.bind(this)}><i className="icofont icofont-search"></i> Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Scoped, novel class names only (epod-tab-*) - verified none of them exist
                        anywhere else in this project, so this <style> block cannot affect any other
                        page. The .epod-tab-* rules need !important to win over encss.css's own
                        .btn-current/.btn-defaultc !important rules (shared by 12 other files, never
                        edited directly); the two-class selector keeps that override scoped to
                        exactly these three buttons. (The counter-box styling that used to live here
                        was reverted per the Layout Cleanup task - counters are back to their plain,
                        pre-existing markup below.) */}
                    <style>{`
                        .epod-counter-row > .col{position:relative;}
                        /* Every counter tile here is clickable (it switches the grid to that list) but carries the
                           shared .cursorDefault class, which forces the plain arrow. Scoped to this row only, so the
                           other screens that use .cursorDefault are unaffected. */
                        .epod-counter-row > .col.cursorDefault,.epod-counter-row > .col.cursorDefault .cirlce-d{cursor:pointer;}
                        .epod-tab-pending.btn-current{background-color:#fff3cd !important;border-color:#ffb300 !important;color:#7a4b00 !important;}
                        .epod-tab-pending.btn-defaultc{background-color:#fff8e6 !important;border-color:#ffe1a8 !important;color:#8a6d3b !important;}
                        .epod-tab-closed.btn-current{background-color:#d4edda !important;border-color:#34a853 !important;color:#14532d !important;}
                        .epod-tab-closed.btn-defaultc{background-color:#eafaf0 !important;border-color:#bfe8cc !important;color:#2f6b47 !important;}
                        .epod-tab-invalid.btn-current{background-color:#f8d7da !important;border-color:#dc3545 !important;color:#7a1420 !important;}
                        .epod-tab-invalid.btn-defaultc{background-color:#fdeeef !important;border-color:#f3c2c6 !important;color:#8a3b41 !important;}
                    `}</style>
                    <div className='card col-xl-12 col-md-12 beffect'>
                        <div className="card-body crm-numbers pb-3">
                            <div className="row epod-counter-row">
                                <div className="col cursorDefault">
                                    <div className=" cirlce-d" onClick={this.onClickTab.bind(this, "total")}>
                                        <span className="sptile"><i className="fa fa-globe f24 greenfont"></i><br /> Total PODs</span>
                                        <h4 className="greenfont f40"><span className="counter"><CountUp end={this.state.totalrecords.length} /></span></h4>
                                        {this.renderCounterNotch("total")}
                                    </div>
                                </div>
                                <div className="col cursorDefault" onClick={this.onClickTab.bind(this, "pending")}>
                                    <div className=" cirlce-d">
                                        <span className="sptile"><i className="icofont icofont-clock-time f22 txt-warning"></i><br /> {getDisplayLabel('pending_to_upload', localStorage.getItem('user_type'))}</span>
                                        <h4 className="txt-warning f40"><span className="counter"><CountUp end={pending.length} /></span></h4>
                                        {this.renderCounterNotch("pending")}
                                    </div>
                                </div>
                                <div className="col cursorDefault" onClick={this.onClickTab.bind(this, "invalid")}>
                                    <div className=" cirlce-d">
                                        <span className="sptile"><i className="icofont icofont-close-circled f24 txt-danger"></i><br />Invalid Docket</span>
                                        <h4 className="txt-danger f40"><span className="counter"><CountUp end={this.state.invalidDocketRecords.length} /></span></h4>
                                        {this.renderCounterNotch("invalid")}
                                    </div>
                                </div>
                                {this.isAlAdmin() &&
                                 [
                                    { key: "late_al", title: "Late POD - AL Approver", cls: "txt-danger", icon: "icofont-file-document", badges: ["icofont-exclamation-circle", "icofont-check-alt"] },
                                    { key: "pending_dealer", title: "Pending with Dealer", cls: "txt-warning", icon: "icofont-user-alt-3" },
                                    { key: "awaiting_al", title: "Awaiting AL Review", cls: "txt-info", icon: "icofont-user-alt-3", badges: ["icofont-check-alt"] },
                                ].map(c => (
                                    <div className="col cursorDefault" key={c.key} onClick={this.onClickTab.bind(this, c.key)}>
                                        <div className=" cirlce-d">
                                            <span className="sptile"><span style={{ position: 'relative', display: 'inline-block' }}>
                                                    <i className={"icofont " + c.icon + " f24 " + c.cls}></i>
                                                    {(c.badges || []).length > 0 && <span style={{ position: 'absolute', right: -14, bottom: -2, fontSize: 11, lineHeight: 1, whiteSpace: 'nowrap' }}>
                                                        {c.badges.map(b => <i key={b} className={"icofont " + b + " " + c.cls}></i>)}
                                                    </span>}
                                                </span><br />{c.title}</span>
                                            <h4 className={c.cls + " f40"}><span className="counter"><CountUp end={this.getAlAdminCounterRows(c.key).length} /></span></h4>
                                            {this.renderCounterNotch(c.key)}
                                        </div>
                                    </div>
                                ))}
                                <div className="col cursorDefault">
                                    <div className=" cirlce-d" onClick={this.onClickTab.bind(this, "closed")}>
                                        <span className="sptile"><i className="icofont icofont-check-circled f24 greenfont"></i><br />Closed PODs</span>
                                        <h4 className="txt-success f40"><span className="counter"><CountUp end={this.state.totalrecords.length - pending.length} /></span></h4>
                                        {this.renderCounterNotch("closed")}
                                    </div>
                                </div>
                                {/* {isEnmovillogin && (
                                    <div className="col cursorDefault" onClick={this.onClickTab.bind(this, "verified")}>
                                        <div className="cirlce-d">
                                            <span className="sptile">
                                                <i className="fa fa-check f24 greenfont"></i><br />
                                                OCR Verified
                                            </span>
                                            <h4 className="txt-success f40">
                                                <span className="counter">
                                                    <CountUp end={this.state.ocrVerifiedCount || 0} />
                                                </span>
                                            </h4>
                                        </div>
                                    </div>
                                )} */}
                            </div>
                        </div>
                    </div>
                    <div className='card col-xl-12 col-md-12 beffect'>

                        <div className='card-body'>
                            <div className="card-header d-sm-flex align-items-center justify-content-between mb-4">

                                {/* Layout-only fix (no behavior/API change) - .button-group itself has no CSS rule
                                    anywhere in this project (verified), so these buttons previously relied on
                                    nothing but default Bootstrap .btn spacing. Kept scoped to inline styles here
                                    rather than touching encss.css's shared .btn-current/.btn-defaultc rules, which
                                    12 other unrelated components also use. Semantic colors (Part 10) are applied via
                                    the scoped .epod-tab-* <style> block above, for the same reason. */}
                                <div className="button-group" style={{ display: 'flex', flexWrap: 'wrap', border: '1px solid #ddd', borderRadius: '4px', overflow: 'hidden' }}>
                                    {/* Part H/L - config-driven tab visibility. A disabled tab is not
                                        rendered at all (never greyed-out) - counters above are a
                                        completely separate concern and are never affected by this. */}
                                    {this.state.podTabsConfig.tabs.pending.enabled ?
                                        <button type="button" className={"btn epod-tab-pending " + (this.state.tabOne)}
                                            style={{ padding: '8px 16px', margin: 0, borderRadius: 0, borderRight: '1px solid #ddd', lineHeight: '1.4' }}
                                            onClick={this.onClickTab.bind(this, "pending")}>Pending</button>
                                        : null}
                                    {this.state.podTabsConfig.tabs.closed.enabled ?
                                        <button type="button" className={"btn epod-tab-closed " + (this.state.tabTow)}
                                            style={{ padding: '8px 16px', margin: 0, borderRadius: 0, borderRight: '1px solid #ddd', lineHeight: '1.4' }}
                                            onClick={this.onClickTab.bind(this, "closed")}>Closed</button>
                                        : null}
                                    {this.state.podTabsConfig.tabs.invalid_docket.enabled ?
                                        <button type="button" className={"btn epod-tab-invalid " + (this.state.tabThree)}
                                            style={{ padding: '8px 16px', margin: 0, borderRadius: 0, lineHeight: '1.4' }}
                                            onClick={this.onClickTab.bind(this, "invalid")}>Invalid Docket</button>
                                        : null}
                                </div>
                                <div className="col-2">
                                    {/* <label className="">Shipping Type</label> */}
                                    <Select
                                        value={this.state.shipType}
                                        placeholder="Shipping Type"
                                        name="shipType"
                                        options={[
                                            { value: "all", label: "All" },
                                            { value: "05", label: "Courier by surface" },//05 
                                            { value: "07", label: "Courier by air" }, //07
                                            { value: "22", label: "Courier by Train" },//22 
                                            { value: "PTL", label: "Part truck Load" }, //47,48 
                                            { value: "FTL", label: "Full truck Load" },//"01", "02", "03", "04", "10", "11", "12", "14", "15", "17", "18", "21", "24", "25","29", "30", "31", "32", "45", "46"
                                            { value: "86", label: "Adjustment Load" },
                                            { value: "74", label: "Multi Point Delivery" },
                                            { value: "ODC", label: "Over Dimensional Cargo" },
                                            { value: "HD", label: "Hand Delivery" }

                                        ]}
                                        onChange={this.onChangeShipType.bind(this)}
                                    />
                                </div>

                            </div>

                            {/* <div className="col-xl-3 col-lg-3 form-group">
                                <label>Select Month To Get Monthly Data</label>
                                <Datetime
                                    value={this.state.startDate}
                                    disableCloseOnClickOutside={false}
                                    closeOnSelect={true}
                                    inputProps={{ placeholder: 'From', name: 'start_date', autoComplete: 'off', readOnly: true }}
                                    dateFormat="YYYY-MM"
                                    name="start_date"
                                    onChange={this.handlerStartDateTime} />
                            </div> */}

                            <div className="row">
                                <div className="col-xl-12 col-md-12 mb-4">
                                    {/* Layout Cleanup task - this used to be a *second*, nested
                                        `.card.shadow` wrapping only the grid, inside the outer
                                        `.card` that already wraps the tabs (card-header) above -
                                        the "card inside card" look. Flattened to a plain,
                                        unstyled container (h-100/py-2 spacing kept, no
                                        border/shadow/background of its own) so the grid sits
                                        directly under the tabs in one workspace. */}
                                    <div className="epod-grid-container h-100 py-2">

                                        <div className="row">
                                            <div className="col-sm-12">
                                                {
                                                /*(this.state.tabOne === 'btn-current')?
                                                <button className="float-right btn btn-warning" onClick={this.setBulkUploadScan}>
                                                    Upload Scan QR
                                                </button>
                                                :""
                                                */}
                                                {/* Same button look as the courier consignments page (cc-btn / cc-layoutbtns in encss.css) */}
                                                <div className="cc-layoutbtns">
                                                    {(this.state.tabOne === 'btn-current') ?
                                                        <button type="button" className="btn btn-success cc-btn" onClick={this.setBulkUploadEpod}>
                                                            <i className="icofont icofont-cloud-upload"></i> Bulk Upload E-Pod
                                                        </button>
                                                        : ""}
                                                    <button type="button" className="btn btn-info cc-btn" title="Reset to default layout" aria-label="Reset to default layout" onClick={this.onClickResetGridState}>
                                                        <i className="icofont icofont-refresh"></i> Reset
                                                    </button>
                                                    <button type="button" className="btn btn-danger cc-btn" title="Save grid layout" aria-label="Save grid layout" onClick={this.onClickSaveGridState}>
                                                        <i className="icofont icofont-save"></i> Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{ width: "100%", height: "70vh" }} className="ag-theme-balham">
                                            <AgGridReact
                                                modules={modules}
                                                rowData={rowData}
                                                columnDefs={columnDefs}
                                                defaultColDef={defaultColDef}
                                                enableRangeSelection={true}
                                                enableCharts={true}
                                                detailCellRendererParams={detailCellRendererParams}
                                                masterDetail={true}
                                                onGridReady={this.onGridReady}
                                                onNewColumnsLoaded={() => this.applySavedGridState(false)}
                                                sideBar={sideBar}
                                                frameworkComponents={frameworkComponents}
                                                statusBar={statusBar}
                                                stopEditingWhenGridLosesFocus={true}
                                                paginationPageSize={paginationPageSize}
                                                suppressRowClickSelection={true}
                                                pagination={true}
                                                headerHeight={50}
                                                gridOptions={{
                                                    context: { componentParent: this }
                                                }}
                                                rowSelection={rowSelection}
                                                onCellClicked={this.onCellClicked}

                                            />
                                        </div>

                                    </div>

                                </div>

                                <div className={"dataLoadpage " + (loadshow)}>
                                </div>
                                <div className={"dataLoadpageimg " + (loadshow)}>
                                    <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                                </div>
                                <div className={"overlay-part " + (overly)} onClick={this.onClickHideAll}></div>



                            </div>



                        </div>

                    </div>
                    {/* manual_upload_slider */}
                    <div className={"slide-r " + (manual_upload_slider)} style={{ overflow: "hidden" }}>
                        <h3 className="subH">Upload Manual Orders
                            <span
                                className="float-right closebtn"
                                style={{ marginRight: "25px" }}
                                onClick={this.onCloseSliderDiv}
                            >
                                X
                            </span>
                        </h3>
                        <div className="slide-r-body" style={{ position: "relative" }}>
                            <div className="container-fluid">
                                <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadManualBulkFormHandler}>
                                    <div className="row form-group col-xl-12 col-lg-12">
                                        <label className="col-xl-4 col-lg-4">Select Gc Way Bill No</label>
                                        <Select
                                            className="border-radius-0 col-xl-6 col-lg-6"
                                            isMulti={false}
                                            id="selectedGcWayBillNo"
                                            value={gc_way_bill_No_sel}
                                            onChange={this.setSelectedGcWayNo}
                                            style={{ borderRadius: "0px" }}
                                            options={gcWayBillList} required />
                                    </div>
                                    <div className="form-group mt-20p">
                                        <label className="">Upload File</label>
                                        <input type="file" id="manualUploadFile" name="uploadFile" onChange={this.changeManualFileHandler} className="form-control" required />
                                    </div>
                                    {/* <div className='p-2' id="appednCSVData"></div> */}
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-success cc-btn cc-btn-form"><i className="icofont icofont-check-circled"></i> Submit</button>
                                        <button type="button" onClick={this.resetUpload} className="btn btn-default cc-btn"><i className="icofont icofont-close-circled"></i> Cancel</button>
                                    </div>
                                </form>
                                {/* <p className='pl-3' style={{ color: 'red' }}> please format the dates in yyyy-mm-dd hh:mm before uploading</p> */}

                                <div className="form-group">
                                    <a className="btn btn-primary cc-btn cc-btn-form" href={require('../../assets/json/bulk_manual_cons_upload.csv')} target="_blank"><i className="icofont icofont-download"></i> Sample Template</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* multiple bulk uploads of pods */}
                <div className={"slide-r " + (this.state.bulkslidershow)}>
                    <div className="slide-r-title">
                        <h4>Upload Bulk POD
                            <span
                                className="float-right closebtn"
                                style={{ marginRight: "25px" }}
                                onClick={this.onCloseSliderDiv}
                            >
                                X
                            </span>
                        </h4>
                    </div>
                    <div className="col-sm-12">
                        <div className="slide-r-body">
                            <form className="theme-form" id="formBulkPOD" method="POST" enctype="multipart/form-data" onSubmit={this.uploadDocument}>
                                <div className="row p-20p">

                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Delivered Date<span className="rclr fbold">*</span></label>
                                        <Datetime
                                            disableCloseOnClickOutside={false}
                                            closeOnSelect={true}
                                            inputProps={{ placeholder: '', name: 'startDate', autoComplete: 'off', readOnly: true, value: this.state.delivered_date }}
                                            dateFormat="YYYY-MM-DD"
                                            timeFormat={false}
                                            name="startDate"
                                            // value={this.state.delivered_date}
                                            onChange={this.changeDateTimeValue.bind(this)}
                                        />
                                    </div>
                                    <p className='pl-3' style={{ color: 'red' }}> please rename the file with gc_waybill_no, Before uploading DeliveryDate, e.g. gcwaybillno_28-02-2023</p>
                                    <p className='pl-3' style={{ color: 'red' }}> if gc_waybill_no mentioned in file name matches with row gc_waybill_no, then it is uploaded by mapping the file to that row.</p>
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Upload Document<span className="rclr fbold">*</span></label>
                                        <input type="file" name="podDoc" id="podDoc" className="form-control" onChange={this.changeBulkFileHandler} required multiple />
                                    </div>
                                    {/* {multiplePodDocs.length > 0 ?
                                                    <>
                                                        <ul>
                                                            {multiplePodDocs.map((e, i) => (
                                                                <li key={i} className="p2">{i} .{e.name}</li>
                                                            ))}
                                                        </ul> */}
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success cc-btn cc-btn-form" disabled={this.state.uploadPodSubmitting}><i className="icofont icofont-cloud-upload"></i> {this.state.uploadPodSubmitting ? 'Uploading...' : 'Upload'}</button>
                                        <button type="button" className="btn btn-default cc-btn" onClick={this.hideSlideBlock} disabled={this.state.uploadPodSubmitting}><i className="icofont icofont-close-circled"></i> Cancel</button>
                                    </div>
                                    {/* </> : "" */}
                                    {/* // } */}

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"slide-r " + (this.state.sliderscanshow)}>
                    <div className="slide-r-title">
                        <h4>Upload Bulk Scan code
                            <span
                                className="float-right closebtn"
                                style={{ marginRight: "25px" }}
                                onClick={this.onCloseSliderDiv}
                            >
                                X
                            </span>
                        </h4>
                    </div>
                    <div className="col-sm-12">
                        <div className="slide-r-body">
                            <form className="theme-form" id="formBulkSingle" method="POST" enctype="multipart/form-data" onSubmit={this.uploadScanCode}>
                                <div className="row p-20p">

                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Delivered Date<span className="rclr fbold">*</span></label>
                                        <Datetime
                                            disableCloseOnClickOutside={false}
                                            closeOnSelect={true}
                                            inputProps={{ placeholder: '', name: 'startDate', autoComplete: 'off', readOnly: true, value: this.state.delivered_date }}
                                            dateFormat="YYYY-MM-DD"
                                            timeFormat={false}
                                            name="startDate"
                                            // value={this.state.delivered_date}
                                            onChange={this.changeDateTimeValue.bind(this)}
                                        />
                                    </div>
                                    <p className='pl-3' style={{ color: 'red' }}> please rename the file with gc_waybill_no , Before uploading DeliveryDate, e.g. gcwaybillno_28-02-2023</p>
                                    <p className='pl-3' style={{ color: 'red' }}> if gc_waybill_no mentioned in file name matches with row gc_waybill_no, then it is uploaded by mapping the file to that row.</p>
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Upload Document<span className="rclr fbold">*</span></label>
                                        <input type="file" multiple name="File" id="File" className="form-control" onChange={this.
                                            changeBulkFileSaveCode} required />
                                    </div>
                                    {/* {multiplePodDocs.length > 0 ?
                                                    <>
                                                        <ul>
                                                            {multiplePodDocs.map((e, i) => (
                                                                <li key={i} className="p2">{i} .{e.name}</li>
                                                            ))}
                                                        </ul> */}
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success cc-btn cc-btn-form"><i className="icofont icofont-cloud-upload"></i> Upload</button>
                                        <button type="button" className="btn btn-default cc-btn" onClick={this.hideSlideBlock}><i className="icofont icofont-close-circled"></i> Cancel</button>
                                    </div>
                                    {/* </> : "" */}
                                    {/* // } */}

                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/*sliderBlock2 ,crd-bg p-10p, slide-body, theme  */}
                <div className={"slide-r " + (this.state.slidershow)}>
                    <div className="slide-r-title">
                        <h4>Upload POD
                            <span
                                className="float-right closebtn"
                                style={{ marginRight: "25px" }}
                                onClick={this.onCloseSliderDiv}
                            >
                                X
                            </span>
                        </h4>
                    </div>


                    <div className="col-sm-12">
                        <div className="slide-r-body">
                            <form className="theme-form" method="POST" id="formPOD" enctype="multipart/form-data" onSubmit={this.uploadDocument}>
                                <div className="row p-20p">
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Delivered Date<span className="rclr fbold">*</span></label>
                                        {/* <input type="text" name="delivered_date" id="delivered_date" value={this.state.delivered_date} className="form-control" onChange={this.changeHandler} required /> */}
                                        {/*                                         
                                        <Datetime
                                            inputProps={{ placeholder: '', name: 'startDate', autoComplete: 'off', readOnly: true }}
                                            disableCloseOnClickOutside={false}
                                            closeOnSelect={true}
                                            dateFormat="YYYY-MM-DD"
                                            timeFormat={false}
                                            // timeFormat="HH:mm"
                                            name="startDate"
                                            value={this.state.delivered_date}
                                            onChange={this.changeDateTimeValue.bind(this)}
                                        /> */}
                                        <input type="text" name="startDate" className="form-control" value={this.state.delivered_date} required />

                                    </div>
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Upload Document<span className="rclr fbold">*</span></label>
                                        <input type="file" name="epodDoc" id="epodDoc" className="form-control" onChange={this.changeFileHandler} required />
                                    </div>
                                    {this.state.uploadPodError ?
                                        <div className="form-group col-sm-12 mb-20p">
                                            <div className="text-danger">{this.state.uploadPodError}</div>
                                        </div>
                                        : null}
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success cc-btn cc-btn-form" disabled={this.state.uploadPodSubmitting}><i className="icofont icofont-cloud-upload"></i> {this.state.uploadPodSubmitting ? 'Uploading...' : 'Upload'}</button>
                                        <button type="button" className="btn btn-default cc-btn" onClick={this.hideSlideBlock} disabled={this.state.uploadPodSubmitting}><i className="icofont icofont-close-circled"></i> Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"slide-r " + (this.state.update_row_slider)} style={{ overflow: "hidden" }}>
                    <h3 className="subH"> Update Row Details
                        <span
                            className="float-right closebtn"
                            style={{ marginRight: "25px" }}
                            onClick={this.onCloseSliderDiv}
                        >
                            X
                        </span>
                    </h3>
                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className="row col-xl-12 col-lg-12 ml-0p n-p-0"></div><div className={"row"} style={{ padding: '5px 0px', width: '100%', zIndex: '9999', }} >
                            <form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={this.onUpdateConsignmentDetails}>
                                <div className="col-xl-12 col-lg-12 row form-group">
                                    <label className="col-xl-12 col-lg-12">Transit Date*</label>
                                    <Datetime
                                        // value={this.state.transit_data_for_update}
                                        disableCloseOnClickOutside={false}
                                        closeOnSelect={true}
                                        inputProps={{ placeholder: 'Transit Date', name: 'transitdate', autoComplete: 'off', readOnly: true, value: this.state.transit_data_for_update }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm:ss"
                                        name="transitdate"
                                        className="col-xl-12 col-lg-12"
                                        onChange={this.handlerTransitDateTime.bind(this)}
                                    />
                                    <p className={`${this.state.errMsg} text-danger`} style={{ marginLeft: "18px" }}>Transit date should be greater than or equal to gc date</p>
                                </div>
                                <div className="col-xl-12 col-lg-12 row form-group">
                                    <label className="col-xl-12 col-lg-12">Location*</label>
                                    <div style={{ width: "100%", marginRight: "30px" }}>
                                        <input type="text" placeholder="Enter Location" id="location_for_update" name="location_for_update" className="form-control col-xl-12 col-lg-12" style={{ marginLeft: '15px' }} />
                                    </div>
                                </div>
                                <div className="col-xl-12 col-lg-12 row form-group">
                                    <label className="col-xl-12 col-lg-12">Status*</label>
                                    <Select
                                        className="col-xl-12"
                                        onChange={(e) => this.setState({
                                            status_for_update: e,
                                            show_delivered_date: e.value == 'Delivered' ? true : false
                                        })}
                                        value={this.state.status_for_update}
                                        options={[
                                            { label: 'In Transit', value: 'In Transit' },
                                            { label: 'Out For Delivery', value: 'Out For Delivery' },
                                            { label: 'Delivered', value: 'Delivered' },
                                            { label: 'CANCELLED', value: 'CANCELLED' },
                                        ]}
                                        required={true}
                                    />
                                </div>

                                {this.state.show_delivered_date ?
                                    <>
                                        <div className="col-xl-12 col-lg-12 row form-group">
                                            <label className="col-xl-12 col-lg-12">Delivered Date *</label>
                                            <Datetime
                                                // value={this.state.delivered_date_for_update}
                                                disableCloseOnClickOutside={false}
                                                closeOnSelect={true}
                                                inputProps={{ placeholder: 'Delivery Date', autoComplete: 'off', readOnly: true, value: this.state.delivered_date_for_update }}
                                                dateFormat="YYYY-MM-DD"
                                                timeFormat="HH:mm:ss"
                                                className="col-xl-12 col-lg-12"
                                                onChange={this.handlerUpdateDeliveredDateTime.bind(this)}
                                            />
                                        </div>
                                        <div className="col-xl-12 col-lg-12 row form-group mb-20p">
                                            <label className="col-xl-12 col-lg-12">Upload Document</label>
                                            <div className="col-xl-12 col-lg-12" style={{ width: "100%", marginRight: "30px" }} >
                                                <input type="file" name="epodDocforupdate" id="epodDocforupdate" className="form-control" onChange={this.changeFileHandlerForupdate} />
                                            </div>
                                        </div>
                                    </>
                                    : ""}
                                <div className="col-xl-12 col-lg-12 form-group">
                                    <button type="submit" className="btn btn-success cc-btn cc-btn-form"><i className="icofont icofont-check-circled"></i> Submit</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function groupBy(list, keyGetter) {
    const map11 = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map11.get(key);
        if (!collection) {
            map11.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map11;
}